/* eslint-disable */

<template>
  <b-container class="form main_style" fluid="true">
    <navbar />
    <p style="font-weight: bolder; font-size: 24px; text-align: center">
      บันทึกข้อมูลแปลงสำรวจ
    </p>
    <!--Section1-->
    <b-row>
      <b-col
        class="rectangle_box py-3 my-3"
        cols="12"
        lg="10"
        md="12"
        sm="12"
        xl="8"
      >
        <b-row class="mx-1">
          <b-col class="d-flex justify-content-start text-green"
            >ข้อมูลทั่วไป</b-col
          >
          <b-col class="d-flex justify-content-end">
            <span v-if="this.form.plant_code">
              รหัสข้อมูล :{{ this.form.plant_code }}
            </span>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" lg="6" md="6" sm="12">
            <b-row v-if="!this.form.status_id < 3" class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left none-padding-right"
                cols="12"
                lg="5"
                md="10"
              >
                การเพิ่มข้อมูล
              </b-col>
              <b-col class="mx-auto" cols="10" md="7" sm="7">
                <b-form-group v-slot="{ ariaDescribedby }">
                  <b-form-radio-group
                    id="radio-group-1"
                    v-model="isNewPlant"
                    :options="select_plant_input_options"
                    :aria-describedby="ariaDescribedby"
                    name="radio-options"
                  ></b-form-radio-group>
                </b-form-group>
              </b-col>
            </b-row>

            <template v-if="this.plant && this.isNewPlant == 0">
              <b-row class="mt-3">
                <b-col
                  align="center"
                  class="text-lg-right text-left none-padding-right"
                  cols="12"
                  lg="5"
                  md="10"
                  >ข้อมูลพืช
                </b-col>
                <b-col class="mx-auto" cols="10" md="7" sm="7">
                  <multiselect
                    id="bio_name"
                    :disabled="this.form.plant_code.length > 0"
                    v-model="bio_name_selected"
                    :initialValues="bio_name_selected"
                    :options="this.bio_name_option"
                    class="multiselect-style2 custom-multiselect"
                    deselect-label="ยกเลิก"
                    label="name"
                    placeholder="ชื่อพืช"
                    select-label=""
                    selectedLabel=""
                    track-by="id"
                    @input="setFormData"
                  ></multiselect>
                </b-col>
              </b-row>
            </template>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left none-padding-right"
                cols="12"
                lg="5"
                md="10"
                >รหัสชุมชน
                <b-icon icon="info-circle-fill" variant="secondary"></b-icon>
              </b-col>
              <b-col class="text-lg-left text-right" cols="10" md="7" sm="7">
                {{ community_code }}
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left none-padding-right"
                cols="12"
                lg="5"
                md="10"
                ><b class="font-require">*</b>รหัสพันธุ์พืช
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('รหัสพันธุ์พืช')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="7" sm="7">
                <b-form-input
                  id="bio_code"
                  v-model="form.bio_code"
                  :state="bio_code"
                  class="input_text"
                  placeholder="รหัสพันธุ์ไม้"
                  type="text"
                ></b-form-input>
                <b-form-invalid-feedback id="msg_feedback">
                  โปรดกรอกข้อมูล
                </b-form-invalid-feedback>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left none-padding-right"
                cols="12"
                lg="5"
                md="10"
                ><b class="font-require">*</b>ชื่อพืช

                <b-icon
                  v-b-tooltip.hover.top="getTooltip('ชื่อพืช')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="7" sm="7">
                <!--                <multiselect-->
                <!--                  v-model="bio_name_search"-->
                <!--                  :close-on-select="true"-->
                <!--                  :options="bio_name_option"-->
                <!--                  label="name"-->
                <!--                  @close="setValue"-->
                <!--                  @search-change="getBioname"-->
                <!--                  track-by="value"-->
                <!--                  :searchable="true"-->
                <!--                  :show-labels="false"-->
                <!--                  class="multiselect-style2 custom-multiselect"-->
                <!--                  placeholder="ชื่อพืช"-->
                <!--                ></multiselect>-->
                <!--                <multiselect-->
                <!--                  id="bio_name"-->
                <!--                  @search-change="getBioname"-->
                <!--                  v-model="bio_name_search"-->
                <!--                  :initialValues="bio_name_selected"-->
                <!--                  :options="this.bio_name_option"-->
                <!--                  class="multiselect-style2 custom-multiselect"-->
                <!--                  deselect-label="ยกเลิก"-label="ยกเลิก"-->
                <!--                  label="name"-->
                <!--                  :clear-on-select="false"-->
                <!--                  preserve-search-->
                <!--                  placeholder="ชื่อพืช"-->
                <!--                  select-label=""-->
                <!--                  selectedLabel=""-->
                <!--                  track-by="id"-->
                <!--                  @input="setBio(bio_name_selected)"-->
                <!--                  @close="setValue"-->
                <!--                >-->
                <!--                </multiselect>-->
                <b-form-input
                  v-model="form.bio_name"
                  :state="bio_name"
                  class="input_text"
                  placeholder="ชื่อพืช"
                  type="text"
                ></b-form-input>
                <b-form-invalid-feedback id="msg_feedback">
                  โปรดกรอกข้อมูล
                </b-form-invalid-feedback>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left none-padding-right"
                cols="12"
                lg="5"
                md="10"
                >ชื่อพันธ์ุพืช
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('ชื่อพันธ์ุพืช')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="7" sm="7">
                <b-form-input
                  v-model="form.bio_species_name"
                  class="input_text"
                  placeholder="ชื่อพันธ์ุพืช"
                  type="text"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left none-padding-right"
                cols="12"
                lg="5"
                md="10"
                >ชื่อวงศ์
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('ชื่อวงศ์')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="7" sm="7">
                <b-form-input
                  v-model="form.bio_family_name"
                  class="input_text"
                  placeholder="ชื่อวงศ์"
                  type="text"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left none-padding-right"
                cols="12"
                lg="5"
                md="10"
                >ชื่อวิทยาศาสตร์
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('ชื่อวิทยาศาสตร์')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="7" sm="7">
                <b-form-input
                  v-model="form.bio_scientific_name"
                  class="input_text"
                  placeholder="ชื่อวิทยาศาสตร์"
                  type="text"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left none-padding-right"
                cols="12"
                lg="5"
                md="10"
                >ชื่อผู้ตั้งชนิดพรรณไม้
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('ชื่อผู้ตั้งชนิดพรรณไม้')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="7" sm="7">
                <b-form-input
                  v-model="form.author_name"
                  class="input_text"
                  placeholder="ชื่อผู้ตั้งชนิดพรรณไม้"
                  type="text"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left none-padding-right"
                cols="12"
                lg="5"
                md="10"
                ><b class="font-require">*</b>ชื่อท้องถิ่น
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('ชื่อท้องถิ่น')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="7" sm="7">
                <b-form-input
                  v-model="form.bio_local_name"
                  :state="bio_local_name"
                  class="input_text"
                  placeholder="ชื่อท้องถิ่น"
                  type="text"
                ></b-form-input>
                <b-form-invalid-feedback id="msg_feedback">
                  โปรดกรอกข้อมูล
                </b-form-invalid-feedback>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left none-padding-right"
                cols="12"
                lg="5"
                md="10"
                >ฤดูเก็บเกี่ยว
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('ฤดูเก็บเกี่ยว')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="7" sm="7">
                <!--                <b-form-input-->
                <!--                  v-model="form.harvest_season"-->
                <!--                  class="input_text"-->
                <!--                  placeholder="ฤดูเก็บเกี่ยว"-->
                <!--                  type="text"-->
                <!--                ></b-form-input>-->
                <textarea
                  v-model="form.harvest_season"
                  class="form-control"
                  placeholder="ฤดูเก็บเกี่ยว"
                  type="text"
                ></textarea>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" lg="6" md="6" sm="12">
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left none-padding-right"
                cols="12"
                lg="5"
                md="10"
                ><b class="font-require">*</b>กลุ่มชนิดพืช
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('กลุ่มชนิดพืช')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="7" sm="7">
                <multiselect
                  id="categories"
                  v-model="category_selected"
                  :initialValues="category_selected_array"
                  :options="this.categoriesOption"
                  class="multiselect-style2 custom-multiselect"
                  deselect-label="ยกเลิก"
                  label="name"
                  placeholder="กลุ่มชนิดพืช"
                  select-label=""
                  selectedLabel=""
                  track-by="id"
                  @input="
                    (opt) => (this.form.category_id = opt ? opt.id : null)
                  "
                ></multiselect>
                <b-form-invalid-feedback :state="category" id="msg_feedback">
                  โปรดกรอกข้อมูล
                </b-form-invalid-feedback>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left none-padding-right"
                cols="12"
                lg="5"
                md="10"
                ><b class="font-require">*</b>ลักษณะวิสัย
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('ลักษณะวิสัย')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
                <!--                <template v-for="x in habit_selected">-->
                <!--                  {{ x.name }}-->
                <!--                </template>-->
              </b-col>
              <b-col class="mx-auto" cols="10" md="7" sm="7">
                <multiselect
                  id="habit"
                  v-model="habit_selected"
                  :options="this.habitsOption"
                  class="multiselect-style2 custom-multiselect"
                  deselect-label="ยกเลิก"
                  label="name"
                  multiple
                  placeholder="ลักษณะวิสัย"
                  select-label=""
                  selectedLabel=""
                  track-by="id"
                  @input="habitId"
                ></multiselect>
                <b-form-invalid-feedback id="msg_feedback" :state="habit">
                  โปรดกรอกข้อมูล
                </b-form-invalid-feedback>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left none-padding-right"
                cols="12"
                lg="5"
                md="10"
              >
              </b-col>
              <b-col class="mx-auto" cols="10" md="7" sm="7">
                <b-form-input
                  v-model="form.habit_description"
                  class="input_text"
                  placeholder="คำอธิบายเพิ่มเติม..."
                  type="text"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col class="my-2" cols="12" md="12" sm="12">
                <b-row>
                  <b-col
                    align="center"
                    class="text-lg-right text-left none-padding-right"
                    cols="12"
                    lg="5"
                    md="10"
                    >อายุ/ปี
                    <b-icon
                      v-b-tooltip.hover.top="getTooltip('อายุ')"
                      icon="info-circle-fill"
                      variant="secondary"
                    ></b-icon>
                  </b-col>
                  <b-col class="mx-auto" cols="10" md="7" sm="7">
                    <b-form-input
                      v-model="form.age"
                      class="input_text"
                      max="120"
                      min="0"
                      oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"
                      onkeydown="if(event.key==='.'){event.preventDefault();}"
                      placeholder="อายุ"
                      type="number"
                    ></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
              <b-col class="my-2" cols="12" md="12" sm="12">
                <b-row>
                  <b-col
                    align="center"
                    class="text-lg-right text-left none-padding-right"
                    cols="12"
                    lg="5"
                    md="10"
                    >เส้นรอบวง/ซม.
                    <b-icon
                      v-b-tooltip.hover.top="getTooltip('เส้นรอบวง')"
                      icon="info-circle-fill"
                      variant="secondary"
                    ></b-icon>
                  </b-col>
                  <b-col class="mx-auto" cols="10" md="7" sm="7">
                    <b-form-input
                      v-model="form.size"
                      class="input_text"
                      max="120"
                      min="0"
                      oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"
                      onkeydown="if(event.key==='.'){event.preventDefault();}"
                      placeholder="เส้นรอบวง"
                      type="number"
                    ></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left none-padding-right"
                cols="12"
                lg="5"
                md="10"
                >ลักษณะเด่น
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('ลักษณะเด่น')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="7" sm="7">
                <!--                <b-form-input-->
                <!--                  v-model="form.characteristic"-->
                <!--                  class="input_text"-->
                <!--                  placeholder="ลักษณะเด่น"-->
                <!--                  type="text"-->
                <!--                ></b-form-input>-->
                <textarea
                  v-model="form.characteristic"
                  class="form-control"
                  placeholder="ลักษณะเด่น"
                  type="text"
                ></textarea>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left none-padding-right"
                cols="12"
                lg="5"
                md="10"
                ><b class="font-require">*</b>แหล่งที่พบ
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('แหล่งที่พบ')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="7" sm="7">
                <multiselect
                  id="habitat"
                  v-model="habitat_selected"
                  :initialValues="habitat_selected"
                  :options="this.habitatsOption"
                  class="multiselect-style2 custom-multiselect"
                  deselect-label="ยกเลิก"
                  label="name"
                  placeholder="แหล่งที่พบ"
                  select-label=""
                  selectedLabel=""
                  track-by="name"
                  @input="(opt) => (form.habitat = opt ? opt.id : null)"
                ></multiselect>
                <b-form-invalid-feedback :state="habitat" id="msg_feedback">
                  โปรดกรอกข้อมูล
                </b-form-invalid-feedback>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left none-padding-right"
                cols="12"
                lg="5"
                md="10"
              >
              </b-col>
              <b-col class="mx-auto" cols="10" md="7" sm="7">
                <b-form-input
                  v-model="form.habitat_description"
                  class="input_text"
                  placeholder="คำอธิบายเพิ่มเติม..."
                  type="text"
                ></b-form-input>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <!-- <b-row>
          <b-col cols="12" lg="6" md="6" sm="12">




          </b-col>
        </b-row> -->
      </b-col>
    </b-row>
    <!--Section1.1-->

    <br />
    <!--Section2-->
    <b-row>
      <b-col
        class="rectangle_box py-3 my-3"
        cols="12"
        lg="10"
        md="12"
        sm="12"
        xl="8"
      >
        <b-row>
          <b-col>
            <b-row class="mx-1">
              <b-col class="d-flex justify-content-start text-green"
                >การใช้ประโยชน์ในท้องถิ่น
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('การใช้ประโยชน์ในท้องถิ่น')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
            </b-row>
            <span v-for="(option, i) in benefitsOption" :key="option.id">
              <b-row v-if="form.benefit[i]" class="mt-3">
                <b-col
                  align="center"
                  class="text-left mx-3 px-5"
                  cols="12"
                  lg="3"
                  md="3"
                  offset-lg="1"
                  offset-md="1"
                  offset-sm="1"
                  offset-xl="1"
                  sm="3"
                  xl="3"
                >
                  <b-form-checkbox
                    size="lg"
                    @change="onBenefitCheckbox($event, i)"
                    v-model="form.benefit[i].isChecked"
                  >
                    {{ option.name }}
                  </b-form-checkbox>
                </b-col>
                <b-col class="mx-auto" cols="10" lg="8" md="8" sm="8" xl="8">
                  <b-form-input
                    v-model="form.benefit[i].benefit_description"
                    :disabled="
                      !form.benefit[i].isChecked &&
                      !form.benefit[i].benefit_description
                    "
                    :placeholder="'คำอธิบายของ' + `${option.name}`"
                    class="input_text"
                    type="text"
                  ></b-form-input>
                </b-col>
              </b-row>
            </span>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <br />
    <!--Section3-->
    <b-row>
      <b-col
        class="rectangle_box py-3 my-3"
        cols="12"
        lg="10"
        md="12"
        sm="12"
        xl="8"
      >
        <b-row>
          <b-col>
            <b-row class="mx-1">
              <b-col class="d-flex justify-content-start text-green"
                >ภูมิปัญญาท้องถิ่น
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('ภูมิปัญญาท้องถิ่น')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
            </b-row>
            <span v-for="(knowledgeLvl_1, i) in knowledge" :key="i">
              <b-row class="mt-3 my-3">
                <b-col align="center" class="text-left mx-5 my-3" cols="12">
                  <b-form-checkbox
                    size="lg"
                    button-variant="warning"
                    :ref="'checkLvl1_' + i"
                    v-model="
                      checkInput[
                        knowledgeLvl_1[0].knowledge.knowledge_level1_id
                      ]
                    "
                    @change="onKnowledgeLvl1Checkbox($event, knowledgeLvl_1)"
                  >
                    {{ knowledgeLvl_1[0].knowledge.name }}
                  </b-form-checkbox>
                </b-col>
                <b-col class="mx-auto" cols="10" lg="9" md="9" sm="9" xl="9">
                  <span v-for="(knowledgeLvl_2, j) in knowledgeLvl_1" :key="j">
                    <b-row>
                      <b-col
                        class="mx-auto text-left"
                        cols="10"
                        lg="4"
                        md="4"
                        sm="4"
                        xl="4"
                      >
                        <b-form-checkbox
                          size="lg"
                          :ref="
                            'checkLvl2_' + knowledgeLvl_2.knowledge_level2_id
                          "
                          @change="onKnowledgeCheckbox($event, knowledgeLvl_2)"
                          v-model="
                            checkInput[
                              knowledgeLvl_2.knowledge_level1_id +
                                '_' +
                                knowledgeLvl_2.knowledge_level2_id
                            ]
                          "
                          :disabled="!checkInput[i]"
                        >
                          {{ knowledgeLvl_2.name }}
                        </b-form-checkbox>
                      </b-col>
                      <b-col
                        class="mx-auto"
                        cols="10"
                        lg="8"
                        md="8"
                        sm="8"
                        xl="8"
                      >
                        <b-form-input
                          :ref="'text' + knowledgeLvl_2.knowledge_level2_id"
                          v-model="
                            form.knowledge[knowledgeLvl_2.knowledge_level2_id]
                          "
                          :placeholder="
                            'คำอธิบายของ' + `${knowledgeLvl_2.name}`
                          "
                          :disabled="
                            !checkInput[
                              knowledgeLvl_2.knowledge_level1_id +
                                '_' +
                                knowledgeLvl_2.knowledge_level2_id
                            ]
                          "
                          class="input_text my-2"
                          type="text"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                  </span>
                </b-col>
              </b-row>
            </span>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <br />
    <!--Section4-->
    <b-row>
      <b-col
        class="rectangle_box py-3 my-3"
        cols="12"
        lg="10"
        md="12"
        sm="12"
        xl="8"
      >
        <b-row class="mx-1">
          <b-col class="d-flex justify-content-start text-green"
            >ข้อมูลสำรวจ</b-col
          >
        </b-row>
        <!--        <b-row class="mx-1">-->
        <!--          <b-col class="d-flex justify-content-start">-->
        <!--            &lt;!&ndash;            <template v-if="this.survey.length > 0">&ndash;&gt;-->
        <!--            &lt;!&ndash;              <multiselect&ndash;&gt;-->
        <!--            &lt;!&ndash;                id="survey"&ndash;&gt;-->
        <!--            &lt;!&ndash;                v-model="survey_selected"&ndash;&gt;-->
        <!--            &lt;!&ndash;                :initialValues="this.survey_selected"&ndash;&gt;-->
        <!--            &lt;!&ndash;                :options="this.survey_option"&ndash;&gt;-->
        <!--            &lt;!&ndash;                class="multiselect-style2 custom-multiselect"&ndash;&gt;-->
        <!--            &lt;!&ndash;                deselect-label="ยกเลิก"-label="ยกเลิก"&ndash;&gt;-->
        <!--            &lt;!&ndash;                label="name"&ndash;&gt;-->
        <!--            &lt;!&ndash;                placeholder="แปลง"&ndash;&gt;-->
        <!--            &lt;!&ndash;                select-label=""&ndash;&gt;-->
        <!--            &lt;!&ndash;                selectedLabel=""&ndash;&gt;-->
        <!--            &lt;!&ndash;                track-by="name"&ndash;&gt;-->
        <!--            &lt;!&ndash;                @input="setSurvey"&ndash;&gt;-->
        <!--            &lt;!&ndash;              ></multiselect>&ndash;&gt;-->
        <!--            &lt;!&ndash;            </template>&ndash;&gt;-->
        <!--          </b-col>-->
        <!--        </b-row>-->

        <b-row>
          <b-col cols="12" lg="6" md="6" sm="12">
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left none-padding-right"
                cols="12"
                lg="5"
                md="10"
                ><b class="font-require">*</b>วันที่สำรวจพบ
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('วันที่สำรวจพบ')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="7" sm="8">
                <b-form-input
                  v-model="form.survey_date"
                  :state="survey_date"
                  class="input_text w-100"
                  style="height: 38px"
                  type="date"
                />
                <b-form-invalid-feedback id="msg_feedback">
                  โปรดกรอกข้อมูล
                </b-form-invalid-feedback>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left none-padding-right"
                cols="12"
                lg="5"
                md="10"
                >จำนวน/ต้น
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('จำนวน')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="7" sm="8">
                <b-form-input
                  v-model="form.survey_amount"
                  class="input_text"
                  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"
                  onkeydown="if(event.key==='.'){event.preventDefault();}"
                  placeholder="จำนวน"
                  type="number"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col class="my-2" cols="12" md="12" sm="12">
                <b-row>
                  <b-col
                    align="center"
                    class="text-lg-right text-left none-padding-right"
                    cols="12"
                    lg="5"
                    md="10"
                    >พิกัดต้นพันธุ์
                    <b-icon
                      v-b-tooltip.hover.top="getTooltip('พิกัดต้นพันธุ์')"
                      icon="info-circle-fill"
                      variant="secondary"
                    ></b-icon>
                  </b-col>
                  <b-col class="mx-auto" cols="10" md="7" sm="8">
                    <b-row>
                      <b-col cols="6" class="none-padding-right">
                        <b-form-input
                          v-model="form.survey_bio_lat"
                          class="input_text"
                          placeholder="ละติจูด"
                          type="number"
                        ></b-form-input>
                      </b-col>
                      <b-col cols="6" class="none-padding-right">
                        <b-form-input
                          v-model="form.survey_bio_lon"
                          class="input_text"
                          placeholder="ลองติจูด"
                          type="number"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                  </b-col>
                  <br />
                  <b-col offset="2" cols="10">
                    <b-row>
                      <b-col cols="6" class="px-1">
                        <b-button
                          @click="$bvModal.show('bv-modal-SurveyBio')"
                          class="text-center my-2 pb-3 btn btn-block w-100"
                        >
                          ระบุค่าด้วย Map
                        </b-button>
                      </b-col>
                      <b-col cols="6" class="px-1">
                        <b-button
                          v-b-modal="'modal1'"
                          class="text-center my-2 pb-3 btn btn-block w-100"
                          >ระบุค่าด้วย UTM
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-modal id="bv-modal-SurveyBio" hide-footer>
                    <template #modal-header="{ close }">
                      <div>กรุณาเลือกพิกัด</div>
                      <div class="pointer" @click="close()">x</div>
                    </template>
                    <div>
                      <GmapAutocomplete
                        @place_changed="setPlace1"
                        style="width: 100%"
                      />
                    </div>
                    <gmap-map
                      id="survay_bio"
                      :center="startLocation1"
                      :zoom="15"
                      style="width: 100%; height: 420px"
                      @click="setPlaceNEWSurveyBio"
                    >
                      <gmap-marker
                        v-for="(item, key) in this.markers_survay_bio"
                        :key="key"
                        :clickable="true"
                        :position="getPositionSurveyBio(item)"
                        @click="toggleInfoSurveyBio()"
                      ></gmap-marker>
                    </gmap-map>
                  </b-modal>
                  <b-modal
                    hide-header-close
                    hide-footer
                    id="modal1"
                    title="แปลงค่า UTM"
                  >
                    <b-row>
                      <b-col
                        class="mx-auto"
                        cols="12"
                        md="12"
                        sm="12"
                        style="padding-right: 7%"
                      >
                        <b-row>
                          <b-col cols="6" class="none-padding-right">
                            <b-form-input
                              v-model="utm1.east"
                              class="input_text"
                              placeholder="East"
                              type="number"
                            ></b-form-input>
                          </b-col>
                          <b-col cols="6" class="none-padding-right">
                            <b-form-input
                              v-model="utm1.north"
                              class="input_text"
                              placeholder="North"
                              type="number"
                            ></b-form-input>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col
                        class="mx-auto mt-2"
                        cols="12"
                        md="12"
                        sm="12"
                        style="padding-right: 7%"
                      >
                        <b-row>
                          <b-col cols="6" class="none-padding-right">
                            <b-form-input
                              v-model="utm1.zone_number"
                              class="input_text"
                              placeholder="Zone"
                              type="number"
                            ></b-form-input>
                          </b-col>
                          <b-col cols="6" class="none-padding-right">
                            <select
                              v-model="utm1.zone_letter"
                              class="form-control"
                            >
                              <option value="N">N</option>
                              <option value="S">S</option>
                            </select>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col class="mt-3">
                        <button
                          @click="utmConvert()"
                          class="btn btn-outline-secondary"
                          style="width: 100% !important"
                        >
                          แปลง
                        </button>
                      </b-col>
                    </b-row>
                  </b-modal>

                  <!--                  <b-col class="mx-auto" cols="10" md="7" sm="8">-->
                  <!--                    <b-row>-->
                  <!--                      <b-col cols="6" class="none-padding-right">-->
                  <!--                        <b-form-input-->
                  <!--                          v-model="utm1.east"-->
                  <!--                          class="input_text"-->
                  <!--                          placeholder="East"-->
                  <!--                          type="number"-->
                  <!--                        ></b-form-input>-->
                  <!--                      </b-col>-->
                  <!--                      <b-col cols="6" class="none-padding-right">-->
                  <!--                        <b-form-input-->
                  <!--                          v-model="utm1.north"-->
                  <!--                          class="input_text"-->
                  <!--                          placeholder="North"-->
                  <!--                          type="number"-->
                  <!--                        ></b-form-input>-->
                  <!--                      </b-col>-->
                  <!--                    </b-row>-->
                  <!--                  </b-col>-->
                  <!--                  <b-col-->
                  <!--                    align="center"-->
                  <!--                    class="text-lg-right text-left none-padding-right mt-2"-->
                  <!--                    cols="12"-->
                  <!--                    lg="5"-->
                  <!--                    md="10"-->
                  <!--                  >-->
                  <!--                  </b-col>-->
                  <!--                  <b-col class="mx-auto mt-2" cols="10" md="7" sm="8">-->
                  <!--                    <b-row>-->
                  <!--                      <b-col cols="4" class="none-padding-right">-->
                  <!--                        <b-form-input-->
                  <!--                          v-model="utm1.zone_number"-->
                  <!--                          class="input_text"-->
                  <!--                          placeholder="Zone"-->
                  <!--                          type="number"-->
                  <!--                        ></b-form-input>-->
                  <!--                      </b-col>-->
                  <!--                      <b-col cols="4" class="none-padding-right">-->
                  <!--                        <select v-model="utm1.zone_letter" class="form-control">-->
                  <!--                          <option value="N">N</option>-->
                  <!--                          <option value="S">S</option>-->
                  <!--                        </select>-->
                  <!--                      </b-col>-->
                  <!--                      <b-col cols="4">-->
                  <!--                        <button-->
                  <!--                          @click="utmConvert()"-->
                  <!--                          class="btn btn-outline-secondary"-->
                  <!--                        >-->
                  <!--                          แปลง-->
                  <!--                        </button>-->
                  <!--                      </b-col>-->
                  <!--                    </b-row>-->
                  <!--                  </b-col>-->
                </b-row>
              </b-col>
              <b-col class="my-2" cols="12" md="12" sm="12"></b-col>
            </b-row>
          </b-col>
          <b-col cols="12" lg="6" md="6" sm="12">
            <template v-if="this.survey && this.survey.length > 0">
              <b-row class="mt-3">
                <b-col
                  align="center"
                  class="text-lg-right text-left none-padding-right text-green"
                  cols="12"
                  lg="5"
                  md="10"
                  >ข้อมูลแปลงสำรวจ
                </b-col>
                <b-col class="mx-auto" cols="10" md="7" sm="8">
                  <multiselect
                    id="survey"
                    v-model="survey_selected"
                    :initialValues="this.survey_selected"
                    :options="this.survey_option"
                    class="multiselect-style2 custom-multiselect"
                    deselect-label="ยกเลิก"
                    label="name"
                    placeholder="แปลง"
                    select-label=""
                    selectedLabel=""
                    track-by="name"
                    @input="setSurvey"
                  ></multiselect>
                </b-col>
              </b-row>
            </template>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left none-padding-right"
                cols="12"
                lg="5"
                md="10"
                >รหัสแปลงสำรวจ
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('รหัสแปลงสำรวจ')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="7" sm="8">
                <b-form-input
                  v-model="form.survey_plot_code"
                  class="input_text"
                  placeholder="รหัสแปลงธนาคาร"
                  type="text"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left none-padding-right"
                cols="12"
                lg="5"
                md="10"
                >ชื่อแปลง
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('ชื่อแปลง')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="7" sm="8">
                <b-form-input
                  v-model="form.survey_plot_name"
                  class="input_text"
                  placeholder="ชื่อแปลง"
                  type="text"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left none-padding-right"
                cols="12"
                lg="5"
                md="10"
                >ที่ตั้งแปลง
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('ที่ตั้งแปลง')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="7" sm="8">
                <b-form-input
                  v-model="form.survey_plot_address"
                  class="input_text"
                  placeholder="ที่ตั้งแปลง"
                  type="text"
                ></b-form-input>
              </b-col>
            </b-row>

            <b-row class="mt-3">
              <b-col class="my-2" cols="12" md="12" sm="12">
                <b-row>
                  <b-col
                    align="center"
                    class="text-lg-right text-left none-padding-right"
                    cols="12"
                    lg="5"
                    md="10"
                    >จังหวัด
                  </b-col>
                  <b-col class="mx-auto" cols="10" md="7" sm="8">
                    <multiselect
                      id="survey_plot_province"
                      v-model="province_survey_selected"
                      :initialValues="province_survey_selected"
                      :options="this.province_survey"
                      class="multiselect-style2 custom-multiselect"
                      deselect-label="ยกเลิก"
                      label="name"
                      placeholder="จังหวัด"
                      select-label=""
                      selectedLabel=""
                      track-by="id"
                      @input="getDistrict(province_survey_selected, 'survey')"
                      @select="(opt) => (form.survey_plot_province = opt.code)"
                    ></multiselect>
                  </b-col>
                </b-row>
              </b-col>
              <b-col class="my-2" cols="12" md="12" sm="12">
                <b-row>
                  <b-col
                    align="center"
                    class="text-lg-right text-left none-padding-right"
                    cols="12"
                    lg="5"
                    md="10"
                    >อำเภอ
                  </b-col>
                  <b-col class="mx-auto" cols="10" md="7" sm="8">
                    <multiselect
                      id="survey_plot_district"
                      v-model="district_survey_selected"
                      :disabled="province_survey_selected.length <= 0"
                      :initialValues="this.district_survey_selected"
                      :options="this.district_survey"
                      class="multiselect-style2 custom-multiselect"
                      deselect-label="ยกเลิก"
                      label="name"
                      placeholder="อำเภอ"
                      select-label=""
                      selectedLabel=""
                      track-by="name"
                      @input="
                        getSubDistrict(district_survey_selected, 'survey')
                      "
                      @select="
                        (opt) => (form.survey_plot_district = opt.district_id)
                      "
                    ></multiselect>
                  </b-col>
                </b-row>
              </b-col>
              <b-col class="my-2" cols="12" md="12" sm="12">
                <b-row>
                  <b-col
                    align="center"
                    class="text-lg-right text-left none-padding-right"
                    cols="12"
                    lg="5"
                    md="10"
                    >ตำบล
                  </b-col>
                  <b-col class="mx-auto" cols="10" md="7" sm="8">
                    <multiselect
                      id="survey_plot_sub_district"
                      v-model="sub_district_survey_selected"
                      :disabled="district_survey_selected.length <= 0"
                      :initialValues="this.sub_district_survey_selected"
                      :options="this.sub_district_survey"
                      class="multiselect-style2 custom-multiselect"
                      deselect-label="ยกเลิก"
                      label="name"
                      placeholder="ตำบล"
                      select-label=""
                      selectedLabel=""
                      track-by="name"
                      @input="
                        (opt) =>
                          (form.survey_plot_sub_district = opt.subdistrict_id)
                      "
                      @select="this.sub_district_survey_selected"
                    ></multiselect>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col class="my-2" cols="12" md="12" sm="12">
                <b-row>
                  <b-col
                    align="center"
                    class="text-lg-right text-left none-padding-right"
                    cols="12"
                    lg="4"
                    md="10"
                    >พิกัดแปลง
                    <b-icon
                      v-b-tooltip.hover.top="getTooltip('พิกัดแปลง')"
                      icon="info-circle-fill"
                      variant="secondary"
                    ></b-icon>
                  </b-col>
                  <b-col class="mx-auto" cols="10" md="7" sm="8">
                    <b-row>
                      <b-col cols="6" class="none-padding-right">
                        <b-form-input
                          v-model="form.survey_plot_lat"
                          class="input_text"
                          placeholder="ละติจูด"
                          type="number"
                        ></b-form-input>
                      </b-col>
                      <b-col cols="6" class="none-padding-right">
                        <b-form-input
                          v-model="form.survey_plot_lon"
                          class="input_text"
                          placeholder="ลองติจูด"
                          type="number"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                  </b-col>
                  <br />
                  <b-col offset="2" cols="10">
                    <b-row>
                      <b-col cols="6" class="px-1">
                        <b-button
                          @click="$bvModal.show('bv-modal-SurveyPlot')"
                          class="text-center my-2 pb-3 btn btn-block w-100"
                        >
                          ระบุค่าด้วย Map
                        </b-button>
                      </b-col>
                      <b-col cols="6" class="px-1">
                        <b-button
                          v-b-modal="'modal2'"
                          class="text-center my-2 pb-3 btn btn-block w-100"
                          >ระบุค่าด้วย UTM
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-modal
                    id="bv-modal-SurveyPlot"
                    hide-footer
                    style="z-index: 2"
                  >
                    <template #modal-header="{ close }">
                      <div>กรุณาเลือกพิกัด</div>
                      <div class="pointer" @click="close()">x</div>
                    </template>
                    <div>
                      <GmapAutocomplete
                        @place_changed="setPlace2"
                        style="width: 100%"
                      />
                    </div>
                    <gmap-map
                      id="survay_plot"
                      :center="startLocation2"
                      :zoom="15"
                      style="width: 100%; height: 420px"
                      @click="setPlaceNEWSurveyPlot"
                    >
                      <gmap-marker
                        v-for="(item, key) in this.markers_survay_plot"
                        :key="key"
                        :clickable="true"
                        :position="getPositionSurveyPlot(item)"
                        @click="toggleInfoSurveyPlot()"
                      ></gmap-marker>
                    </gmap-map>
                  </b-modal>
                  <b-modal
                    hide-header-close
                    hide-footer
                    id="modal2"
                    title="แปลงค่า UTM"
                  >
                    <b-row>
                      <b-col
                        class="mx-auto"
                        cols="12"
                        md="12"
                        sm="12"
                        style="padding-right: 7%"
                      >
                        <b-row>
                          <b-col cols="6" class="none-padding-right">
                            <b-form-input
                              v-model="utm2.east"
                              class="input_text"
                              placeholder="East"
                              type="number"
                            ></b-form-input>
                          </b-col>
                          <b-col cols="6" class="none-padding-right">
                            <b-form-input
                              v-model="utm2.north"
                              class="input_text"
                              placeholder="North"
                              type="number"
                            ></b-form-input>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col
                        class="mx-auto mt-2"
                        cols="12"
                        md="12"
                        sm="12"
                        style="padding-right: 7%"
                      >
                        <b-row>
                          <b-col cols="6" class="none-padding-right">
                            <b-form-input
                              v-model="utm2.zone_number"
                              class="input_text"
                              placeholder="Zone"
                              type="number"
                            ></b-form-input>
                          </b-col>
                          <b-col cols="6" class="none-padding-right">
                            <select
                              v-model="utm2.zone_letter"
                              class="form-control"
                            >
                              <option value="N">N</option>
                              <option value="S">S</option>
                            </select>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col class="mt-3">
                        <button
                          @click="utmConvert(2)"
                          class="btn btn-outline-secondary"
                          style="width: 100% !important"
                        >
                          แปลง
                        </button>
                      </b-col>
                    </b-row>
                  </b-modal>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <br />
    <!--Section5-->
    <b-row>
      <b-col
        class="rectangle_box py-3 my-3"
        cols="12"
        lg="10"
        md="12"
        sm="12"
        xl="8"
      >
        <b-row class="mx-1">
          <b-col class="d-flex justify-content-start text-green"
            >ข้อมูลแปลงธนาคาร</b-col
          >
        </b-row>
        <b-row class="mx-1">
          <b-col class="d-flex justify-content-start">
            <!--            <template v-if="this.bank.length > 0">-->
            <!--              <multiselect-->
            <!--                id="bank"-->
            <!--                v-model="bank_selected"-->
            <!--                :initialValues="this.bank_selected"-->
            <!--                :options="this.bank_option"-->
            <!--                class="multiselect-style2 custom-multiselect"-->
            <!--                deselect-label="ยกเลิก"-label="ยกเลิก"-->
            <!--                label="name"-->
            <!--                placeholder="แปลง"-->
            <!--                select-label=""-->
            <!--                selectedLabel=""-->
            <!--                track-by="name"-->
            <!--                @input="setBank"-->
            <!--              ></multiselect>-->
            <!--            </template>-->
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" lg="6" md="6" sm="12">
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left none-padding-right"
                cols="12"
                lg="5"
                md="10"
                ><b class="font-require">*</b>วันที่จัดเก็บ
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('วันที่จัดเก็บ')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="7" sm="8">
                <b-form-input
                  v-model="form.bank_date"
                  :min="form.survey_date"
                  class="input_text w-100"
                  style="height: 38px"
                  type="date"
                />
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left none-padding-right"
                cols="12"
                lg="5"
                md="10"
                >จำนวน/ต้น
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('จำนวน')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="7" sm="8">
                <b-form-input
                  v-model="form.bank_amount"
                  class="input_text bank"
                  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"
                  onkeydown="if(event.key==='.'){event.preventDefault();}"
                  placeholder="จำนวน"
                  type="number"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col class="my-2" cols="12" md="12" sm="12">
                <b-row>
                  <b-col
                    align="center"
                    class="text-lg-right text-left none-padding-right"
                    cols="12"
                    lg="5"
                    md="10"
                    >พิกัดต้นพันธุ์
                    <b-icon
                      v-b-tooltip.hover.top="getTooltip('พิกัดต้นพันธุ์')"
                      icon="info-circle-fill"
                      variant="secondary"
                    ></b-icon>
                  </b-col>
                  <b-col class="mx-auto" cols="10" md="7" sm="8">
                    <b-row class="d-flex justify-content-center">
                      <b-col cols="6" class="none-padding-right">
                        <b-form-input
                          v-model="form.bank_bio_lat"
                          class="input_text"
                          placeholder="ละติจูด"
                          type="number"
                        ></b-form-input>
                      </b-col>
                      <b-col cols="6" class="none-padding-right">
                        <b-form-input
                          v-model="form.bank_bio_lon"
                          class="input_text"
                          placeholder="ลองติจูด"
                          type="number"
                        ></b-form-input>
                      </b-col>
                      <!--                      <b-col cols="2">-->
                      <!--                        <div>-->
                      <!--                          <button-->
                      <!--                            @click="$bvModal.show('bv-modal-BankBio')"-->
                      <!--                            class="btn-circle-no-margin"-->
                      <!--                          >-->
                      <!--                            <b-icon class="text-white" icon="geo-alt"></b-icon>-->
                      <!--                          </button>-->
                      <!--                          <b-modal id="bv-modal-BankBio" hide-footer>-->
                      <!--                            <template #modal-header="{ close }">-->
                      <!--                              <div>กรุณาเลือกพิกัด</div>-->
                      <!--                              <div class="pointer" @click="close()">x</div>-->
                      <!--                            </template>-->
                      <!--                            <gmap-map-->
                      <!--                              id="bank_bio"-->
                      <!--                              :center="startLocation"-->
                      <!--                              :zoom="15"-->
                      <!--                              style="width: 100%; height: 420px"-->
                      <!--                              @click="setPlaceNEWBankBio"-->
                      <!--                            >-->
                      <!--                              &lt;!&ndash; สร้าง marker ตามค่า coordinates ที่เราเซตไว้ แล้ว loop ออกมาแสดงผล &ndash;&gt;-->
                      <!--                              <gmap-marker-->
                      <!--                                v-for="(item, key) in this.markers_bank_bio"-->
                      <!--                                :key="key"-->
                      <!--                                :clickable="true"-->
                      <!--                                :position="getPositionBankBio(item)"-->
                      <!--                                @click="toggleInfoBankBio()"-->
                      <!--                              ></gmap-marker>-->
                      <!--                            </gmap-map>-->
                      <!--                          </b-modal>-->
                      <!--                        </div>-->
                      <!--                      </b-col>-->
                    </b-row>
                  </b-col>

                  <b-col offset="2" cols="10">
                    <b-row>
                      <b-col cols="6" class="px-1">
                        <b-button
                          @click="$bvModal.show('bv-modal-SurveyBank')"
                          class="text-center my-2 pb-3 btn btn-block w-100"
                        >
                          ระบุค่าด้วย Map
                        </b-button>
                      </b-col>
                      <b-col cols="6" class="px-1">
                        <b-button
                          v-b-modal="'modal3'"
                          class="text-center my-2 pb-3 btn btn-block w-100"
                          >ระบุค่าด้วย UTM
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-modal id="bv-modal-SurveyBank" hide-footer>
                    <template #modal-header="{ close }">
                      <div>กรุณาเลือกพิกัด</div>
                      <div class="pointer" @click="close()">x</div>
                    </template>
                    <div>
                      <GmapAutocomplete
                        @place_changed="setPlace3"
                        style="width: 100%"
                      />
                    </div>
                    <gmap-map
                      id="survay_bio"
                      :center="startLocation3"
                      :zoom="15"
                      style="width: 100%; height: 420px"
                      @click="setPlaceNEWBankBio"
                    >
                      <gmap-marker
                        v-for="(item, key) in this.markers_bank_bio"
                        :key="key"
                        :clickable="true"
                        :position="getPositionBankBio(item)"
                        @click="toggleInfoBankBio()"
                      ></gmap-marker>
                    </gmap-map>
                  </b-modal>
                  <b-modal
                    hide-header-close
                    hide-footer
                    id="modal3"
                    title="แปลงค่า UTM"
                  >
                    <b-row>
                      <b-col
                        class="mx-auto"
                        cols="12"
                        md="12"
                        sm="12"
                        style="padding-right: 7%"
                      >
                        <b-row>
                          <b-col cols="6" class="none-padding-right">
                            <b-form-input
                              v-model="utm3.east"
                              class="input_text"
                              placeholder="East"
                              type="number"
                            ></b-form-input>
                          </b-col>
                          <b-col cols="6" class="none-padding-right">
                            <b-form-input
                              v-model="utm3.north"
                              class="input_text"
                              placeholder="North"
                              type="number"
                            ></b-form-input>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col
                        class="mx-auto mt-2"
                        cols="12"
                        md="12"
                        sm="12"
                        style="padding-right: 7%"
                      >
                        <b-row>
                          <b-col cols="6" class="none-padding-right">
                            <b-form-input
                              v-model="utm3.zone_number"
                              class="input_text"
                              placeholder="Zone"
                              type="number"
                            ></b-form-input>
                          </b-col>
                          <b-col cols="6" class="none-padding-right">
                            <select
                              v-model="utm3.zone_letter"
                              class="form-control"
                            >
                              <option value="N">N</option>
                              <option value="S">S</option>
                            </select>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col class="mt-3">
                        <button
                          @click="utmConvert(3)"
                          class="btn btn-outline-secondary"
                          style="width: 100% !important"
                        >
                          แปลง
                        </button>
                      </b-col>
                    </b-row>
                  </b-modal>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" lg="6" md="6" sm="12">
            <template v-if="this.bank && this.bank.length > 0">
              <b-row class="mt-3">
                <b-col
                  align="center"
                  class="text-lg-right text-left none-padding-right"
                  cols="12"
                  lg="5"
                  md="10"
                  >ข้อมูลแปลงธนาคาร
                </b-col>
                <b-col class="mx-auto" cols="10" md="7" sm="8">
                  <multiselect
                    id="bank"
                    v-model="bank_selected"
                    :initialValues="this.bank_selected"
                    :options="this.bank_option"
                    class="multiselect-style2 custom-multiselect"
                    deselect-label="ยกเลิก"
                    label="name"
                    placeholder="แปลง"
                    select-label=""
                    selectedLabel=""
                    track-by="name"
                    @input="setBank"
                  ></multiselect>
                </b-col>
              </b-row>
            </template>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left none-padding-right"
                cols="12"
                lg="5"
                md="10"
                >รหัสแปลงธนาคาร
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('รหัสแปลงธนาคาร')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="7" sm="8">
                <b-form-input
                  v-model="form.bank_plot_code"
                  class="input_text bank"
                  placeholder="รหัสแปลงธนาคาร"
                  type="text"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left none-padding-right"
                cols="12"
                lg="5"
                md="10"
                >ชื่อแปลง
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('ชื่อแปลง')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="7" sm="8">
                <b-form-input
                  v-model="form.bank_plot_name"
                  class="input_text bank"
                  placeholder="ชื่อแปลง"
                  type="text"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left none-padding-right"
                cols="12"
                lg="5"
                md="10"
                ><b class="font-require">*</b>ที่ตั้งแปลง
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('ที่ตั้งแปลง')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="7" sm="8">
                <b-form-input
                  v-model="form.bank_plot_address"
                  class="input_text bank"
                  placeholder="ที่ตั้งแปลง"
                  type="text"
                ></b-form-input>
              </b-col>
            </b-row>

            <b-row class="mt-3">
              <b-col class="my-2" cols="12" md="12" sm="12">
                <b-row>
                  <b-col
                    align="center"
                    class="text-lg-right text-left none-padding-right"
                    cols="12"
                    lg="5"
                    md="10"
                    ><b class="font-require">*</b>จังหวัด
                  </b-col>
                  <b-col class="mx-auto" cols="10" md="7" sm="8">
                    <multiselect
                      id="bank_plot_province"
                      v-model="province_bank_selected"
                      :initialValues="this.province_bank_selected"
                      :options="this.province_bank"
                      class="multiselect-style2 custom-multiselect"
                      deselect-label="ยกเลิก"
                      label="name"
                      placeholder="จังหวัด"
                      select-label=""
                      selectedLabel=""
                      track-by="name"
                      @input="getDistrict(province_bank_selected, 'bank')"
                      @select="(opt) => (form.bank_plot_province = opt.code)"
                    ></multiselect>
                  </b-col>
                </b-row>
              </b-col>
              <b-col class="my-2" cols="12" md="12" sm="12">
                <b-row>
                  <b-col
                    align="center"
                    class="text-lg-right text-left none-padding-right"
                    cols="12"
                    lg="5"
                    md="10"
                    ><b class="font-require">*</b>อำเภอ
                  </b-col>
                  <b-col class="mx-auto" cols="10" md="7" sm="8">
                    <multiselect
                      id="bank_plot_district"
                      v-model="district_bank_selected"
                      :disabled="province_bank_selected.length <= 0"
                      :initialValues="this.district_bank_selected"
                      :options="this.district_bank"
                      class="multiselect-style2 custom-multiselect"
                      deselect-label="ยกเลิก"
                      label="name"
                      placeholder="อำเภอ"
                      select-label=""
                      selectedLabel=""
                      track-by="name"
                      @input="getSubDistrict(district_bank_selected, 'bank')"
                      @select="
                        (opt) => (form.bank_plot_district = opt.district_id)
                      "
                    ></multiselect>
                  </b-col>
                </b-row>
              </b-col>
              <b-col class="my-2" cols="12" md="12" sm="12">
                <b-row>
                  <b-col
                    align="center"
                    class="text-lg-right text-left none-padding-right"
                    cols="12"
                    lg="5"
                    md="10"
                    ><b class="font-require">*</b>ตำบล
                  </b-col>
                  <b-col class="mx-auto" cols="10" md="7" sm="8">
                    <multiselect
                      id="bank_plot_sub_district"
                      v-model="sub_district_bank_selected"
                      :disabled="district_bank_selected.length <= 0"
                      :initialValues="this.sub_district_bank_selected"
                      :options="this.sub_district_bank"
                      class="multiselect-style2 custom-multiselect"
                      deselect-label="ยกเลิก"
                      label="name"
                      placeholder="ตำบล"
                      select-label=""
                      selectedLabel=""
                      track-by="name"
                      @input="
                        (opt) =>
                          (form.bank_plot_sub_district = opt.subdistrict_id)
                      "
                      @select="sub_district_bank_selected"
                    ></multiselect>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col class="my-2" cols="12" md="12" sm="12">
                <b-row>
                  <b-col
                    align="center"
                    class="text-lg-right text-left none-padding-right"
                    cols="12"
                    lg="4"
                    md="10"
                    >พิกัดแปลง
                    <b-icon
                      v-b-tooltip.hover.top="getTooltip('พิกัดแปลง')"
                      icon="info-circle-fill"
                      variant="secondary"
                    ></b-icon>
                  </b-col>
                  <b-col class="mx-auto" cols="10" md="7" sm="8">
                    <b-row>
                      <b-col cols="5" class="none-padding-right">
                        <b-form-input
                          v-model="form.bank_plot_lat"
                          class="input_text"
                          placeholder="ละติจูด"
                          type="number"
                        ></b-form-input>
                      </b-col>
                      <b-col cols="5" class="none-padding-right">
                        <b-form-input
                          v-model="form.bank_plot_lon"
                          class="input_text"
                          placeholder="ลองติจูด"
                          type="number"
                        ></b-form-input>
                      </b-col>
                      <b-col cols="2">
                        <div>
                          <button
                            @click="$bvModal.show('bv-modal-BankPlot')"
                            class="btn-circle-no-margin mr-1"
                          >
                            <b-icon class="text-white" icon="geo-alt"></b-icon>
                          </button>
                          <b-modal id="bv-modal-BankPlot" hide-footer>
                            <template #modal-header="{ close }">
                              <div>กรุณาเลือกพิกัด</div>
                              <div class="pointer" @click="close()">x</div>
                            </template>
                            <gmap-map
                              id="bank_plot"
                              :center="startLocation"
                              :zoom="15"
                              style="width: 100%; height: 420px"
                              @click="setPlaceNEWBankPlot"
                            >
                              <gmap-marker
                                v-for="(item, key) in this.markers_bank_plot"
                                :key="key"
                                :clickable="true"
                                :position="getPositionBankPlot(item)"
                                @click="toggleInfoBankPlot()"
                              ></gmap-marker>
                            </gmap-map>
                          </b-modal>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col offset="2" cols="10">
                    <b-row>
                      <b-col cols="6" class="px-1">
                        <b-button
                          @click="$bvModal.show('bv-modal-Bank')"
                          class="text-center my-2 pb-3 btn btn-block w-100"
                        >
                          ระบุค่าด้วย Map
                        </b-button>
                      </b-col>
                      <b-col cols="6" class="px-1">
                        <b-button
                          v-b-modal="'modal4'"
                          class="text-center my-2 pb-3 btn btn-block w-100"
                          >ระบุค่าด้วย UTM
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-modal id="bv-modal-Bank" hide-footer>
                    <template #modal-header="{ close }">
                      <div>กรุณาเลือกพิกัด</div>
                      <div class="pointer" @click="close()">x</div>
                    </template>
                    <div>
                      <GmapAutocomplete
                        @place_changed="setPlace4"
                        style="width: 100%"
                      />
                    </div>
                    <gmap-map
                      id="survay_bio"
                      :center="startLocation4"
                      :zoom="15"
                      style="width: 100%; height: 420px"
                      @click="setPlaceNEWBankPlot"
                    >
                      <gmap-marker
                        v-for="(item, key) in this.markers_bank_plot"
                        :key="key"
                        :clickable="true"
                        :position="getPositionBankPlot(item)"
                        @click="toggleInfoBankPlot()"
                      ></gmap-marker>
                    </gmap-map>
                  </b-modal>
                  <b-modal
                    hide-header-close
                    hide-footer
                    id="modal4"
                    title="แปลงค่า UTM"
                  >
                    <b-row>
                      <b-col
                        class="mx-auto"
                        cols="12"
                        md="12"
                        sm="12"
                        style="padding-right: 7%"
                      >
                        <b-row>
                          <b-col cols="6" class="none-padding-right">
                            <b-form-input
                              v-model="utm4.east"
                              class="input_text"
                              placeholder="East"
                              type="number"
                            ></b-form-input>
                          </b-col>
                          <b-col cols="6" class="none-padding-right">
                            <b-form-input
                              v-model="utm4.north"
                              class="input_text"
                              placeholder="North"
                              type="number"
                            ></b-form-input>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col
                        class="mx-auto mt-2"
                        cols="12"
                        md="12"
                        sm="12"
                        style="padding-right: 7%"
                      >
                        <b-row>
                          <b-col cols="6" class="none-padding-right">
                            <b-form-input
                              v-model="utm4.zone_number"
                              class="input_text"
                              placeholder="Zone"
                              type="number"
                            ></b-form-input>
                          </b-col>
                          <b-col cols="6" class="none-padding-right">
                            <select
                              v-model="utm4.zone_letter"
                              class="form-control"
                            >
                              <option value="N">N</option>
                              <option value="S">S</option>
                            </select>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col class="mt-3">
                        <button
                          @click="utmConvert(4)"
                          class="btn btn-outline-secondary"
                          style="width: 100% !important"
                        >
                          แปลง
                        </button>
                      </b-col>
                    </b-row>
                  </b-modal>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <br />
    <!--Section6-->
    <b-row>
      <b-col
        class="rectangle_box py-3 my-3"
        cols="12"
        lg="10"
        md="12"
        sm="12"
        xl="8"
      >
        <b-row class="mx-1 text-left">
          <b-col>
            <b class="mr-2 text-green">รูปภาพ</b>
            <!-- <a
                      class="text-left"
                      v-if="this.form.images.length < 5"
                      style="background-color: white; color: #db7f50"
                      @click="chooseFiles()"
                    >
                      <b-icon icon="plus-circle-fill " class="my-auto"></b-icon>
                      เพิ่มรูป
                    </a> -->
            <b-row class="my-3 text-left">
              <!--              <b-col-->
              <!--               -->
              <!--                -->
              <!--                class="text-left"-->
              <!--              >-->
              <b-col
                v-for="(item, i) in image_set"
                style="max-width: 20%"
                class="text-left"
                :key="i"
              >
                <div v-if="!item.image_url">
                  <label
                    class="border border-dark mr-3 d-flex align-items-center justify-content-center pointer"
                    style="height: 130px"
                    :for="`upload${i}`"
                  >
                    <b-icon class="font-title" icon="plus-circle"></b-icon>
                  </label>
                  <input
                    @change="uploadImage($event, i)"
                    :id="`upload${i}`"
                    style="visibility: hidden; width: 0px"
                    type="file"
                    accept="image/*"
                  />
                </div>
                <div v-else>
                  <img
                    class="mr-3 mb-5 fluid"
                    style="width: 100%; height: auto; max-height: 130px"
                    :src="item.image_url"
                    alt=""
                  />
                  <b-icon
                    fab
                    @click="deleteImage(i)"
                    icon="dash-circle"
                    class="delete-img"
                  ></b-icon>
                </div>
                <multiselect
                  v-model="form.imageSelected[i]"
                  :options="imageOption"
                  class="multiselect-style2 custom-multiselect"
                  deselect-label="ยกเลิก"
                  label="name"
                  select-label=""
                  selectedLabel=""
                  placeholder="การแสดงผล"
                ></multiselect>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <br />
    <!--Section submit-->
    <b-row v-if="this.user.user.group_id == 4">
      <b-col class="d-block text-left mr-auto mx-auto" cols="6" md="4">
        <b-row>
          <b-col cols="12" lg="12" md="12" sm="12" xl="6">
            <b-button
              class="text-center my-2 pb-3 btn btn-block"
              style="background: white; border-radius: 25px; color: #bdbdbd"
              @click="goBack()"
            >
              ยกเลิก
            </b-button>
          </b-col>
          <b-col cols="12" lg="12" md="12" sm="12" xl="6">
            <b-button
              class="text-center my-2 pb-3 btn btn-block"
              style="background: #db7f50; border-radius: 25px"
              @click="saveForm(survey_status_old)"
            >
              บันทึก
            </b-button>
          </b-col>
        </b-row>
      </b-col>
      <b-col class="d-block text-right ml-auto mx-auto" cols="6" md="4">
        <b-row v-if="this.form.status_id >= 2">
          <template v-if="this.user.user.group_id != 5">
            <b-col cols="12" lg="12" md="12" sm="12" xl="6">
              <b-button
                v-if="this.form.plant_id"
                class="text-center my-2 pb-3 btn btn-block"
                style="background: #828282; border-radius: 25px"
                @click="saveForm('4')"
              >
                ไม่อนุมัติ
              </b-button>
            </b-col>
            <b-col cols="12" lg="12" md="12" sm="12" xl="6">
              <b-button
                class="text-center my-2 pb-3 btn btn-block"
                style="background: #41634a; border-radius: 25px"
                @click="saveForm('3')"
              >
                อนุมัติ
              </b-button>
            </b-col>
          </template>
        </b-row>
        <!--        <b-row v-else>-->
        <!--          <b-col cols="12" lg="12" md="12" sm="12" xl="6">-->
        <!--            <b-button-->
        <!--              v-if="this.form.plant_id"-->
        <!--              class="text-center my-2 pb-3 btn btn-block"-->
        <!--              style="background: #828282; border-radius: 25px"-->
        <!--              @click="saveForm('4')"-->
        <!--            >-->
        <!--              ไม่อนุมัติ-->
        <!--            </b-button>-->
        <!--          </b-col>-->
        <!--          <b-col cols="12" lg="12" md="12" sm="12" xl="6">-->
        <!--            <b-button-->
        <!--              class="text-center my-2 pb-3 btn btn-block"-->
        <!--              style="background: #41634a; border-radius: 25px"-->
        <!--              @click="saveForm('3')"-->
        <!--            >-->
        <!--              อนุมัติ-->
        <!--            </b-button>-->
        <!--          </b-col>-->
        <!--        </b-row>-->
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col class="d-block text-left mr-auto mx-auto" cols="6" md="4">
        <b-row>
          <b-col cols="12" lg="12" md="12" sm="12" xl="6">
            <b-button
              class="text-center my-2 pb-3 btn btn-block"
              style="background: white; border-radius: 25px; color: #bdbdbd"
              @click="goBack()"
            >
              ยกเลิก
            </b-button>
          </b-col>
          <b-col cols="12" lg="12" md="12" sm="12" xl="6">
            <template v-if="this.user.user.group_id < 5 && form.status_id >= 2">
              <b-button
                class="text-center my-2 pb-3 btn btn-block"
                style="background: #db7f50; border-radius: 25px"
                @click="saveForm(survey_status_old)"
              >
                บันทึก
              </b-button>
            </template>
            <template v-else>
              <b-button
                class="text-center my-2 pb-3 btn btn-block"
                style="background: #db7f50; border-radius: 25px"
                @click="saveForm('1')"
              >
                บันทึกฉบับร่าง
              </b-button>
            </template>
          </b-col>
        </b-row>
      </b-col>
      <b-col class="d-block text-right ml-auto mx-auto" cols="6" md="4">
        <b-row v-if="this.form.status_id >= 2">
          <template v-if="this.user.user.group_id != 5">
            <b-col cols="12" lg="12" md="12" sm="12" xl="6">
              <b-button
                v-if="this.form.plant_id"
                class="text-center my-2 pb-3 btn btn-block"
                style="background: #828282; border-radius: 25px"
                @click="saveForm('4')"
              >
                ไม่อนุมัติ
              </b-button>
            </b-col>
            <b-col cols="12" lg="12" md="12" sm="12" xl="6">
              <b-button
                class="text-center my-2 pb-3 btn btn-block"
                style="background: #41634a; border-radius: 25px"
                @click="saveForm('3')"
              >
                อนุมัติ
              </b-button>
            </b-col>
          </template>
        </b-row>
        <b-row v-else>
          <b-col cols="12" lg="12" md="12" sm="12" xl="6">
            <b-button
              v-if="this.form.plant_id"
              class="text-center my-2 pb-3 btn btn-block"
              style="background: #828282; border-radius: 25px"
              @click="deletePlant"
            >
              ลบ
            </b-button>
          </b-col>
          <b-col cols="12" lg="12" md="12" sm="12" xl="6">
            <b-button
              class="text-center my-2 pb-3 btn btn-block"
              style="background: #41634a; border-radius: 25px"
              @click="saveForm('2')"
            >
              บันทึกและตรวจสอบ
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import navbar from "@/components/navbar";
import Multiselect from "vue-multiselect";
import { mapState } from "vuex";
import Swal from "sweetalert2";
import { domain } from "@/utils/Constants";
import axios from "axios";

export default {
  name: "form",
  data() {
    return {
      image_set: [
        { image_url: null },
        { image_url: null },
        { image_url: null },
        { image_url: null },
        { image_url: null },
      ],
      community_code: "",
      survey_status_old: "",
      isNewPlant: 1,
      select_plant_input_options: [
        { text: "สร้างพืชใหม่", value: 1 },
        { text: "เลือกพืชที่มีอยู่", value: 0 },
      ],
      bank_selected: [],
      bank_option: [],
      survey_selected: [],
      survey_option: [],
      url: domain + "/api/uploadImage",
      markers_survay_bio: [],
      markers_survay_plot: [],
      markers_bank_bio: [],
      markers_bank_plot: [],
      startLocation: {
        lat: 13.7649084,
        lng: 100.5382846,
      },
      startLocation1: {
        lat: 13.7649084,
        lng: 100.5382846,
      },
      startLocation2: {
        lat: 13.7649084,
        lng: 100.5382846,
      },
      startLocation3: {
        lat: 13.7649084,
        lng: 100.5382846,
      },
      startLocation4: {
        lat: 13.7649084,
        lng: 100.5382846,
      },
      SwitchData: true,
      category_selected: [],
      category_selected_array: [],
      bio_name_selected: [],
      bio_name_option: [],
      habit_selected: [],
      habitat_selected: [],
      categoriesOption: [],
      province_survey_selected: [],
      district_survey_selected: [],
      sub_district_survey_selected: [],
      province_bank_selected: [],
      district_bank_selected: [],
      sub_district_bank_selected: [],
      habitsOption: [],
      habitatsOption: [],
      benefitsOption: [],
      benefitsRemarkValue: [],
      knowledgeOption: [],
      checkInput: [],
      checkInputs: [],
      fileList: [],
      image: null,
      knowledgeCheckbok: [],
      imageOption: [
        { id: 1, name: "ไม่แสดงลายละเอียดพืชหลัก" },
        { id: 3, name: "แสดงเป็นรูปหลัก" },
        { id: 2, name: "แสดงเป็นรูปรอง" },
      ],
      tooltipName: [
        {
          name: "วันที่จัดเก็บ",
          tooltip_name: "เลือกวันที่ที่ทำการจัดเก็บพันธุ์พืช",
        },
        { name: "จำนวน", tooltip_name: "ระบุจำนวนต้นที่จัดเก็บ" },
        {
          name: "พิกัดพันธุ์พืช",
          tooltip_name: "ระบุพิกัดต้นพันธุ์ เป็นละติจูดและลองติจูด",
        },
        { name: "รหัสแปลงธนาคาร", tooltip_name: "ระบุรหัสของแปลงธนาคาร" },
        { name: "ชื่อแปลง", tooltip_name: "ระบุชื่อแปลงธนาคาร" },
        {
          name: "ที่ตั้งแปลง",
          tooltip_name: "ระบุที่ตั้งแปลงธนาคาร เช่น ตำบล อำเภอ จังหวัด",
        },
        {
          name: "พิกัดแปลง",
          tooltip_name: "ระบุพิกัดแปลง เป็นละติจูดและลองติจูด",
        },
        {
          name: "รหัสพันธุ์พืช",
          tooltip_name: "ระบุรหัสพันธุ์พืช ที่เป็นรหัสที่ใช้เรียกในชุมชน",
        },
        { name: "ชื่อพืช", tooltip_name: "ชื่อสามัญ" },
        {
          name: "ชื่อวิทยาศาสตร์",
          tooltip_name: "ระบุชื่อวิทยาศาสตร์ของพืช",
        },
        {
          name: "ชื่อผู้ตั้งชนิดพรรณไม้",
          tooltip_name: "ระบุชื่อผู้ตั้งชนิดพรรณไม้ของพืช",
        },
        {
          name: "ชื่อวงศ์",
          tooltip_name: "ระบุชื่อวงศ์ของพืช",
        },
        {
          name: "ชื่อพันธ์ุพืช",
          tooltip_name: "ระบุชื่อพันธ์ุพืช",
        },
        {
          name: "ชื่อท้องถิ่น",
          tooltip_name: "ระบุชื่อพืชที่ใช้เรียกในท้องถิ่น",
        },
        {
          name: "ฤดูเก็บเกี่ยว",
          tooltip_name: "ระบุฤดูที่สามารถเก็บเกี่ยวได้",
        },
        { name: "กลุ่มชนิดพืช", tooltip_name: "เลือกกลุ่มชนิดพืช" },
        { name: "ลักษณะวิสัย", tooltip_name: "เลือกลักษณะวิสัย" },
        { name: "อายุ", tooltip_name: "ระบุอายุของพันธุ์พืช" },
        { name: "เส้นรอบวง", tooltip_name: "ระบุขนาดเส้นรอบวงเป็นเซนติเมตร" },
        { name: "ลักษณะเด่น", tooltip_name: "อธิบายลักษณะเด่นของพันธุ์พืช" },
        {
          name: "แหล่งที่พบ",
          tooltip_name: "เลือกแหล่งที่พบ และอธิบายเพิ่มเติม",
        },
        {
          name: "การใช้ประโยชน์ในท้องถิ่น",
          tooltip_name: "เลือกส่วนที่สามารถนำไปใช้ประโยชน์ และอธิบายประโยชน์",
        },
        {
          name: "ภูมิปัญญาท้องถิ่น",
          tooltip_name:
            "เลือกการใช้ประโยชน์ในเชิงภูมิปัญญาของท้องถิ่น และอธิบายเพิ่มเติม",
        },
        {
          name: "วันที่สำรวจพบ",
          tooltip_name: "เลือกวันที่ที่ทำการสำรวจพันธุ์พืช",
        },
        { name: "จำนวน", tooltip_name: "ระบุจำนวนต้นที่สำรวจพบ" },
        {
          name: "พิกัดพันธุ์",
          tooltip_name: "ระบุพิกัดต้นพันธุ์ เป็นละติจูดและลองติจูด",
        },
        { name: "รหัสแปลงสำรวจ", tooltip_name: "ระบุรหัสของแปลงสำรวจ" },
        { name: "ชื่อแปลง", tooltip_name: "ระบุชื่อแปลงสำรวจ" },
        {
          name: "ที่ตั้งแปลง",
          tooltip_name: "ระบุที่ตั้งแปลงสำรวจ เช่น ตำบล อำเภอ จังหวัด",
        },
        {
          name: "พิกัดแปลง",
          tooltip_name: "ระบุพิกัดแปลง เป็นละติจูดและลองติจูด",
        },
        {
          name: "วันที่จัดเก็บ",
          tooltip_name: "เลือกวันที่ที่ทำการจัดเก็บพันธุ์พืช",
        },
        { name: "จำนวน", tooltip_name: "ระบุจำนวนต้นที่จัดเก็บ" },
        {
          name: "พิกัดต้นพันธุ์",
          tooltip_name: "ระบุพิกัดต้นพันธุ์ เป็นละติจูดและลองติจูด",
        },
        { name: "รหัสแปลงธนาคาร", tooltip_name: "ระบุรหัสของแปลงธนาคาร" },
        { name: "ชื่อแปลง", tooltip_name: "ระบุชื่อแปลงธนาคาร" },
        {
          name: "ที่ตั้งแปลง",
          tooltip_name: "ระบุที่ตั้งแปลงธนาคาร เช่น ตำบล อำเภอ จังหวัด",
        },
        {
          name: "พิกัดแปลง",
          tooltip_name: "ระบุพิกัดแปลง เป็นละติจูดและลองติจูด",
        },
      ],
      bio_name_search: [],
      temp_bio_name: "",
      isSubmit: null,
      utm_lat: "",
      utm_lng: "",
      utm1: {
        east: "",
        north: "",
        zone_number: 47,
        zone_letter: "N",
      },
      utm2: {
        east: "",
        north: "",
        zone_number: 47,
        zone_letter: "N",
      },
      utm3: {
        east: "",
        north: "",
        zone_number: 47,
        zone_letter: "N",
      },
      utm4: {
        east: "",
        north: "",
        zone_number: 47,
        zone_letter: "N",
      },
      currentPlace: null,
      province_survey: [],
      district_survey: [],
      sub_district_survey: [],
      province_bank: [],
      district_bank: [],
      sub_district_bank: [],
    };
  },
  components: {
    navbar,
    Multiselect,
  },
  created() {
    this.prepareFormData();
    if (this.form.status_id) {
      this.survey_status_old = this.form.status_id;
    }
    if (this.form.plant_from != null && this.form.plant_from == "0") {
      this.isNewPlant = 0;
    }
    setTimeout(() => {
      console.log("ready");
    }, 4000);
  },
  computed: {
    ...mapState({
      accessToken: (state) => state.AuthModule.accessToken,
      user: (state) => state.AuthModule.userData,
      community: (state) => state.OptionsModule.community,
      categories: (state) => state.OptionsModule.categories,
      habits: (state) => state.OptionsModule.habits,
      habitats: (state) => state.OptionsModule.habitats,
      benefits: (state) => state.OptionsModule.benefits,
      // province_survey: (state) => state.OptionsModule.province_survey,
      // district_survey: (state) => state.OptionsModule.district_survey,
      // sub_district_survey: (state) => state.OptionsModule.sub_district_survey,
      // province_bank: (state) => state.OptionsModule.province_bank,
      // district_bank: (state) => state.OptionsModule.district_bank,
      // sub_district_bank: (state) => state.OptionsModule.sub_district_bank,
      province: (state) => state.OptionsModule.province,
      district: (state) => state.OptionsModule.district,
      sub_district: (state) => state.OptionsModule.sub_district,
      // knowledge_level1s: (state) => state.OptionsModule.knowledge_level1s,
      knowledge: (state) => state.OptionsModule.knowledge,
      form: (state) => state.formSurveyModule.form,
      plant: (state) => state.OptionsModule.plant,
      survey: (state) => state.OptionsModule.survey,
      bank: (state) => state.OptionsModule.bank,
    }),
    bio_code() {
      if (this.isSubmit === null) return null;
      else if (this.isSubmit || this.form.bio_code.length > 0) return true;
      else return false;
    },
    bio_name() {
      if (this.isSubmit === null) return null;
      else if (this.isSubmit || this.form.bio_name.length > 0) return true;
      else return false;
    },
    bio_local_name() {
      if (this.isSubmit === null) return null;
      else if (this.isSubmit || this.form.bio_local_name.length > 0)
        return true;
      else return false;
    },
    category() {
      if (this.isSubmit === null) return null;
      else if (
        this.isSubmit ||
        (this.category_selected.id && this.form.category_id)
      )
        return true;
      else return false;
    },
    habit() {
      if (this.isSubmit === null) return null;
      else if (this.isSubmit || (this.habit_selected.id && this.form.habit_id))
        return true;
      else return false;
    },
    habitat() {
      if (this.isSubmit === null) return null;
      else if (this.isSubmit || (this.habitat_selected.id && this.form.habitat))
        return true;
      else return false;
    },
    survey_date() {
      if (this.isSubmit === null) return null;
      else if (this.isSubmit || this.form.survey_date.length > 0) return true;
      else return false;
    },
  },
  methods: {
    habitId() {
      // console.log(this.habit_selected);
      // (opt) => (form.habit_id = opt ? opt.id : null)
      let id = "";
      if (this.habit_selected.length > 0)
        this.habit_selected.forEach((x, i) => {
          if (i == this.habit_selected.length - 1) id += x.id;
          else id += x.id + ",";
        });
      this.form.habit_id_multi = id;
      // console.log(this.form.habit_id_multi, "id-multi");
    },
    setPlace1(place) {
      let data = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };
      this.form.survey_bio_lat = data.lat;
      this.form.survey_bio_lon = data.lng;
      this.startLocation1.lat = data.lat;
      this.startLocation1.lng = data.lng;
      let marker = {
        lat: data.lat,
        lng: data.lng,
      };
      this.setLocationSurveyBio(marker);
    },
    setPlace2(place) {
      let data = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };
      this.form.survey_plot_lat = data.lat;
      this.form.survey_plot_lon = data.lng;
      this.startLocation2.lat = data.lat;
      this.startLocation2.lng = data.lng;
      let marker = {
        lat: data.lat,
        lng: data.lng,
      };
      this.setLocationSurveyPlot(marker);
    },
    setPlace3(place) {
      let data = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };
      this.form.bank_bio_lat = data.lat;
      this.form.bank_bio_lon = data.lng;
      this.startLocation3.lat = data.lat;
      this.startLocation3.lng = data.lng;
      let marker = {
        lat: data.lat,
        lng: data.lng,
      };
      this.setPlaceNEWBankBio(marker);
    },
    setPlace4(place) {
      let data = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };
      this.form.bank_plot_lat = data.lat;
      this.form.bank_plot_lon = data.lng;
      this.startLocation4.lat = data.lat;
      this.startLocation4.lng = data.lng;
      let marker = {
        lat: data.lat,
        lng: data.lng,
      };
      this.setPlaceNEWBankPlot(marker);
    },
    utmConvert(zone = 1) {
      let utmObj = require("utm-latlng");
      let utm = new utmObj("WGS 84");
      if (zone == 1) {
        if (
          this.utm1.east &&
          this.utm1.north &&
          this.utm1.zone_number &&
          this.utm1.zone_letter
        ) {
          let data = utm.convertUtmToLatLng(
            this.utm1.east,
            this.utm1.north,
            this.utm1.zone_number,
            this.utm1.zone_letter
          );
          this.form.survey_bio_lat = data.lat;
          this.form.survey_bio_lon = data.lng;
          this.startLocation1.lat = data.lat;
          this.startLocation1.lng = data.lng;
          let marker = {
            lat: data.lat,
            lng: data.lng,
          };
          this.setLocationSurveyBio(marker);
          this.$bvModal.hide("modal1");
        } else {
          Swal.fire({
            title: '<div class="text-error">มีบางอย่างผิดพลาด!</div> ',
            html: `<div class="text-dark"> กรุณากรอกข้อมูล utm ให้ครบ </div>`,
            background: `#fff url(${require("../assets/icons/icon_sweet_alert/background.png")}) no-repeat center center contain`,
            imageUrl: require("../assets/icons/icon_sweet_alert/error.png"),
            imageAlt: "Error",
            confirmButtonText: "ยืนยัน",
            customClass: {
              confirmButton: "cancel-btn pill", //insert class here
            },
          });
        }
      } else if (zone == 3) {
        if (
          this.utm3.east &&
          this.utm3.north &&
          this.utm3.zone_number &&
          this.utm3.zone_letter
        ) {
          let data = utm.convertUtmToLatLng(
            this.utm3.east,
            this.utm3.north,
            this.utm3.zone_number,
            this.utm3.zone_letter
          );
          this.form.bank_bio_lat = data.lat;
          this.form.bank_bio_lon = data.lng;
          this.startLocation3.lat = data.lat;
          this.startLocation3.lng = data.lng;
          let marker = {
            lat: data.lat,
            lng: data.lng,
          };
          this.setLocationBankBio(marker);
          this.$bvModal.hide("modal3");
        } else {
          Swal.fire({
            title: '<div class="text-error">มีบางอย่างผิดพลาด!</div> ',
            html: `<div class="text-dark"> กรุณากรอกข้อมูล utm ให้ครบ </div>`,
            background: `#fff url(${require("../assets/icons/icon_sweet_alert/background.png")}) no-repeat center center contain`,
            imageUrl: require("../assets/icons/icon_sweet_alert/error.png"),
            imageAlt: "Error",
            confirmButtonText: "ยืนยัน",
            customClass: {
              confirmButton: "cancel-btn pill", //insert class here
            },
          });
        }
      } else if (zone == 4) {
        if (
          this.utm4.east &&
          this.utm4.north &&
          this.utm4.zone_number &&
          this.utm4.zone_letter
        ) {
          let data = utm.convertUtmToLatLng(
            this.utm4.east,
            this.utm4.north,
            this.utm4.zone_number,
            this.utm4.zone_letter
          );
          this.form.bank_plot_lat = data.lat;
          this.form.bank_plot_lon = data.lng;
          this.startLocation4.lat = data.lat;
          this.startLocation4.lng = data.lng;
          let marker = {
            lat: data.lat,
            lng: data.lng,
          };
          this.setLocationBankPlot(marker);
          this.$bvModal.hide("modal4");
        } else {
          Swal.fire({
            title: '<div class="text-error">มีบางอย่างผิดพลาด!</div> ',
            html: `<div class="text-dark"> กรุณากรอกข้อมูล utm ให้ครบ </div>`,
            background: `#fff url(${require("../assets/icons/icon_sweet_alert/background.png")}) no-repeat center center contain`,
            imageUrl: require("../assets/icons/icon_sweet_alert/error.png"),
            imageAlt: "Error",
            confirmButtonText: "ยืนยัน",
            customClass: {
              confirmButton: "cancel-btn pill", //insert class here
            },
          });
        }
      } else {
        if (
          this.utm2.east &&
          this.utm2.north &&
          this.utm2.zone_number &&
          this.utm2.zone_letter
        ) {
          let data = utm.convertUtmToLatLng(
            this.utm2.east,
            this.utm2.north,
            this.utm2.zone_number,
            this.utm2.zone_letter
          );
          this.form.survey_plot_lat = data.lat;
          this.form.survey_plot_lon = data.lng;
          this.startLocation2.lat = data.lat;
          this.startLocation2.lng = data.lng;
          let marker = {
            lat: data.lat,
            lng: data.lng,
          };
          this.setLocationSurveyPlot(marker);
          this.$bvModal.hide("modal2");
        } else {
          Swal.fire({
            title: '<div class="text-error">มีบางอย่างผิดพลาด!</div> ',
            html: `<div class="text-dark"> กรุณากรอกข้อมูล utm ให้ครบ </div>`,
            background: `#fff url(${require("../assets/icons/icon_sweet_alert/background.png")}) no-repeat center center contain`,
            imageUrl: require("../assets/icons/icon_sweet_alert/error.png"),
            imageAlt: "Error",
            confirmButtonText: "ยืนยัน",
            customClass: {
              confirmButton: "cancel-btn pill", //insert class here
            },
          });
        }
      }
    },
    onKnowledgeLvl1Checkbox(event, knowledgeLvl_1_Array) {
      if (!event) {
        knowledgeLvl_1_Array.forEach((knowledgeLvl2) => {
          var keycheckbox =
            knowledgeLvl2.knowledge_level1_id +
            "_" +
            knowledgeLvl2.knowledge_level2_id;

          this.onKnowledgeCheckbox(event, knowledgeLvl2);
          this.checkInput[keycheckbox] = false;
        });
      }
    },
    onKnowledgeCheckbox(event, knowledgeLvl_2) {
      if (!event) {
        this.form.knowledge[knowledgeLvl_2.knowledge_level2_id] = "";
      }
    },
    onBenefitCheckbox(status, findIndex) {
      let data = this.form;
      if (!status) {
        data.benefit.forEach((x, index) => {
          if (findIndex === index) {
            x.benefit_description = "";
          }
        });
      }
      this.$store.dispatch("formSurveyModule/bypassBenefit", data.benefit);
    },
    setData() {
      console.log(1);
      if (!this.startLocation) {
        this.geolocationSurveyBio();
        this.geolocationSurveyPlot();
        this.geolocationBankBio();
        this.geolocationBankPlot();
      }
      console.log(2);
      if (this.form.category) {
        this.category_selected = {
          id: this.form.category_id,
          name: this.form.category.name,
        };
      }
      console.log(3);
      if (this.form.habit_id !== "") {
        this.habit_selected = {
          id: this.form.habit_id,
          name: this.form.habit.name,
        };
      } else {
        // this.habit_selected = [];
        this.form.habit.forEach((item) => {
          this.habit_selected.push({
            id: item.habit_id,
            name: item.name,
          });
        });
      }
      console.log(4);
      if (this.form.habitat) {
        let filter = [];
        if (this.habitats.length > 0) {
          filter = this.habitats.filter((data) => {
            return data.habitat_id == this.form.habitat;
          });
          let data = {
            id: this.form.habitat,
            name: filter[0].name,
          };
          this.habitat_selected = data;
        }
      }
      console.log(5);
      if (this.form.survey_plot_province) {
        this.province_survey_selected = this.setProvince(
          this.form.survey_plot_province
        );
      }
      if (this.form.survey_plot_district) {
        this.district_survey_selected = this.setDistrict(
          this.form.survey_plot_district
        );
      }
      if (this.form.survey_plot_sub_district) {
        this.sub_district_survey_selected = this.setSubDistrict(
          this.form.survey_plot_sub_district
        );
      }
      if (this.form.bank_plot_province) {
        this.province_bank_selected = this.setProvince(
          this.form.bank_plot_province
        );
      }
      if (this.form.bank_plot_district) {
        this.district_bank_selected = this.setDistrict(
          this.form.bank_plot_district
        );
      }
      if (this.form.bank_plot_sub_district) {
        this.sub_district_bank_selected = this.setSubDistrict(
          this.form.bank_plot_sub_district
        );
      }
      console.log(6);
      if (this.form.plant_knowledges.length > 0) {
        console.log(this.form.plant_knowledges);
      }
      console.log("finish set data");
      this.prepareKnowLedge();
      Swal.clickConfirm();
    },
    async prepareFormData() {
      Swal.fire({
        title: "ระบบกำลังทำงาน",
        html: "โปรดรอสักครู่...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch("OptionsModule/onGetOption", this.user.user.community_id)
            .then((res) => {
              console.log(res);
              this.province_survey = res.province;
              this.district_survey = res.district;
              this.sub_district_survey = res.sub_district;
              this.province_bank = res.province;
              this.district_bank = res.district;
              this.sub_district_bank = res.sub_district;
              this.categories.forEach((item) => {
                this.categoriesOption.push({
                  id: item.category_id,
                  name: item.name,
                });
              });
              this.habits.forEach((item) => {
                this.habitsOption.push({ id: item.habit_id, name: item.name });
              });
              this.habitats.forEach((item) => {
                this.habitatsOption.push({
                  id: item.habitat_id,
                  name: item.name,
                });
              });
              let benefitObj = [];
              if (this.form.benefit.length === 0) {
                this.benefits.forEach((item) => {
                  this.benefitsOption.push({
                    id: item.benefit_id,
                    name: item.name,
                  });
                  benefitObj.push({
                    benefit_description: "",
                    benefit_id: item.benefit_id,
                    isChecked: false,
                  });
                });
                this.$store.dispatch(
                  "formSurveyModule/bypassBenefit",
                  benefitObj
                );
              } else {
                let benefitData = this.form.benefit;
                let benefitTemplate = [];
                this.benefits.forEach((item) => {
                  this.benefitsOption.push({
                    id: item.benefit_id,
                    benefit_id: item.benefit_id,
                    name: item.name,
                  });
                  benefitTemplate.push({
                    id: item.benefit_id,
                    benefit_description: "",
                    benefit_id: item.benefit_id,
                    name: item.name,
                  });
                });
                benefitData.forEach((item) => {
                  benefitTemplate.forEach((option) => {
                    if (item.benefit_id === option.id) {
                      option.isChecked = item.benefit_description
                        ? true
                        : false;
                      option.benefit_description = item.benefit_description;
                      option.community_id = item.community_id;
                      option.created_at = item.created_at;
                      option.benefit_id = item.benefit_id;
                      option.created_by = item.created_by;
                      option.id = item.id;
                      option.plant_id = item.plant_id;
                      option.updated_at = item.updated_at;
                      option.updated_by = item.updated_by;
                    }
                  });
                });
                this.$store.dispatch(
                  "formSurveyModule/bypassBenefit",
                  benefitTemplate
                );
              }
              this.plant.forEach((item) => {
                this.bio_name_option.push({
                  id: item.view_plant_id,
                  name: item.bio_name,
                });
              });
              // this.plant.forEach((item) => {
              //   this.bio_name_option.push({
              //     id: item.view_plant_id,
              //     name: item.bio_name,
              //   });
              // });
              this.survey.forEach((item) => {
                this.survey_option.push({
                  id: item.id,
                  name: item.survey_plot_name,
                });
              });
              this.bank.forEach((item) => {
                this.bank_option.push({
                  id: item.id,
                  name: item.bank_plot_name,
                });
              });
              this.image_set.forEach((item, index) => {
                if (this.form.images[index]) {
                  item.image_url = this.form.images[index].image_url;
                }
              });
              let communityId = this.form.community_id
                ? this.form.community_id
                : this.user.user.community_id;
              let communityModel = this.community.find(
                (x) => x.community_id === communityId
              );
              this.community_code = communityModel
                ? communityModel.community_code
                : "";
              // this.image_set =
              //   this.form.images && this.form.images.length > 0
              //     ? this.form.images
              //     : [
              //         { id: 1, src: null },
              //         { id: 2, src: null },
              //         { id: 3, src: null },
              //         { id: 4, src: null },
              //         { id: 5, src: null },
              //       ];
              console.log("end1");
              if (this.form.plant_id) {
                console.log("start set data");
                this.setData();
              } else {
                Swal.clickConfirm();
              }
              console.log("end1");
            });
        },
      });
    },

    setFormData() {
      let set_data = [];
      console.log("this.bio_name_selected.id", this.bio_name_selected.id);
      if (this.bio_name_selected.id) {
        set_data = this.plant.filter((item) => {
          return item.view_plant_id == this.bio_name_selected.id;
        });
      }
      console.log("set_data", set_data);
      this.form.bio_name = set_data[0].bio_name;
      this.form.bio_name = "";
      this.form.bio_name = set_data[0].bio_name;
      this.form.bio_scientific_name = set_data[0].bio_scientific_name;
      this.form.bio_local_name = set_data[0].bio_local_name;
      this.form.havest_season = set_data[0].havest_season;

      this.form.category_id = set_data[0].category_id;
      let category_data = [];
      if (this.form.category_id) {
        category_data = this.categories.filter((item) => {
          return item.category_id == this.form.category_id;
        });
      }
      console.log(category_data[0]);
      this.category_selected = {
        id: category_data[0].category_id,
        name: category_data[0].name,
      };
      this.category_selected_array = this.category_selected;
      console.log(" this.category_selected", this.category_selected);

      this.form.habit_id = set_data[0].view_plant_habit_id;
      let habit_data = [];
      if (this.form.habit_id) {
        habit_data = this.habits.filter((item) => {
          return item.habit_id == this.form.habit_id;
        });
      }
      this.habit_selected = {
        id: habit_data[0].habit_id,
        name: habit_data[0].name,
      };
    },
    setSurvey() {
      let set_data = [];
      if (this.survey_selected)
        set_data = this.survey.filter((item) => {
          return item.id == this.survey_selected.id;
        });
      if (set_data.length > 0) {
        this.form.survey_plot_name = set_data[0].survey_plot_name;
        this.form.survey_plot_code = set_data[0].survey_plot_code;
        this.form.survey_plot_address = set_data[0].survey_plot_address;
        this.form.survey_plot_lat = set_data[0].survey_plot_lat;
        this.form.survey_plot_lon = set_data[0].survey_plot_lon;
        this.form.survey_plot_province = set_data[0].survey_plot_province;
        this.form.survey_plot_district = set_data[0].survey_plot_district;
        this.form.survey_plot_sub_district =
          set_data[0].survey_plot_sub_district;

        if (this.form.survey_plot_province) {
          let plot_province = [];
          plot_province = this.province.filter((item) => {
            return item.code == this.form.survey_plot_province;
          });
          this.province_survey_selected = {
            id: plot_province[0].code,
            name: plot_province[0].name,
          };
        }
        if (this.form.survey_plot_district) {
          let plot_district = [];
          plot_district = this.district.filter((item) => {
            return item.district_id == this.form.survey_plot_district;
          });
          this.district_survey_selected = {
            id: plot_district[0].district_id,
            name: plot_district[0].name,
          };
        }
        if (this.form.survey_plot_sub_district) {
          let plot_sub_district = [];
          plot_sub_district = this.sub_district.filter((item) => {
            return item.subdistrict_id == this.form.survey_plot_sub_district;
          });
          this.sub_district_survey_selected = {
            id: plot_sub_district[0].subdistrict_id,
            name: plot_sub_district[0].name,
          };
        }
      } else {
        this.form.survey_plot_name = "";
        this.form.survey_plot_code = "";
        this.form.survey_plot_address = "";
        this.form.survey_plot_lat = "";
        this.form.survey_plot_lon = "";
        this.province_survey_selected = [];
        this.district_survey_selected = [];
        this.sub_district_survey_selected = [];
      }
    },
    setBank() {
      let set_data = [];
      if (this.bank_selected)
        set_data = this.bank.filter((item) => {
          return item.id == this.bank_selected.id;
        });
      if (set_data.length > 0) {
        this.form.bank_plot_name = set_data[0].bank_plot_name;
        this.form.bank_plot_code = set_data[0].bank_plot_code;
        this.form.bank_plot_address = set_data[0].bank_plot_address;
        this.form.bank_plot_lat = set_data[0].bank_plot_lat;
        this.form.bank_plot_lon = set_data[0].bank_plot_lon;
        this.form.bank_plot_province = set_data[0].bank_plot_province;
        this.form.bank_plot_district = set_data[0].bank_plot_district;
        this.form.bank_plot_sub_district = set_data[0].bank_plot_sub_district;

        if (this.form.bank_plot_province) {
          let plot_province = [];
          plot_province = this.province.filter((item) => {
            return item.code == this.form.bank_plot_province;
          });
          this.province_bank_selected = {
            id: plot_province[0].code,
            name: plot_province[0].name,
          };
        }
        if (this.form.bank_plot_district) {
          let plot_district = [];
          plot_district = this.district.filter((item) => {
            return item.district_id == this.form.bank_plot_district;
          });
          this.district_bank_selected = {
            id: plot_district[0].district_id,
            name: plot_district[0].name,
          };
        }
        if (this.form.bank_plot_sub_district) {
          let plot_sub_district = [];
          plot_sub_district = this.sub_district.filter((item) => {
            return item.subdistrict_id == this.form.bank_plot_sub_district;
          });
          this.sub_district_bank_selected = {
            id: plot_sub_district[0].subdistrict_id,
            name: plot_sub_district[0].name,
          };
        }
      } else {
        this.form.bank_plot_name = "";
        this.form.bank_plot_code = "";
        this.form.bank_plot_address = "";
        this.form.bank_plot_lat = "";
        this.form.bank_plot_lon = "";
        this.province_bank_selected = [];
        this.district_bank_selected = [];
        this.sub_district_bank_selected = [];
        // this.form.bank_plot_province = "";
        // this.form.bank_plot_district = "";
        // this.form.bank_plot_sub_district = "";
      }
    },
    calculate(i, j) {
      return parseInt(i) + parseInt(j);
    },
    async saveForm(survey_status) {
      this.form.plant_from = this.isNewPlant;
      //survey_status
      // 1	ฉบับร่าง
      // 2	ตรวจสอบ
      // 3	อนุมัติ
      // 4	ไม่อนุมัติ
      // Prepare Plant Benefit Data
      let temp_benefit = this.form.benefit;
      temp_benefit.forEach((item) => {
        if (item.isChecked) {
          item.benefit_description = item.benefit_description
            ? item.benefit_description
            : " ";
        }
      });
      this.$store.dispatch("formSurveyModule/bypassBenefit", temp_benefit);
      this.form.images = this.image_set.filter((x) => x.image_url !== null);
      // Validate Data
      let temp_data = this.form;
      const errorList = this.verifyData(temp_data);
      if (errorList.length == 0) {
        this.form.status_id = survey_status;
        this.isSubmit = true;
        // 3	อนุมัติ
        if (this.form.status_id == 3) {
          await this.confirmPublish();
        } else {
          await this.confirmSave(survey_status);
        }
      } else {
        this.isSubmit = false;

        Swal.fire({
          title: '<div class="text-error">การบันทึกข้อมูลไม่สำเร็จ!</div> ',
          html: `<div class="text-dark">โปรดกรอก ${errorList.toString()} </div>`,
          background: `#fff url(${require("../assets/icons/icon_sweet_alert/background.png")}) no-repeat center center contain`,
          imageUrl: require("../assets/icons/icon_sweet_alert/error.png"),
          imageAlt: "Error",
          confirmButtonText: "ยืนยัน",
          customClass: {
            confirmButton: "cancel-btn pill", //insert class here
          },
        });
      }
    },

    async confirmPublish() {
      const inputOptions = new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            publish: "เผยแพร่",
            no_publish: "ไม่เผยแพร่",
          });
        }, 1000);
      });

      const value = await Swal.fire({
        title: "การเผยแพร่?",
        input: "radio",
        inputOptions: inputOptions,
        allowEscapeKey: false,
        allowOutsideClick: false,
        cancelButtonText: "ยกเลิก",
        confirmButtonText: "ตกลง",
        cancelButtonColor: "#FF0000",
        showCancelButton: true,
        inputValidator: (value) => {
          if (!value) {
            return "โปรดเลือกการเผยแพร่!";
          } else {
            this.form.publish_status = value === "publish" ? 1 : 0;
            this.confirmSave();
          }
        },
      });
    },

    async confirmSave(status = null) {
      Swal.fire({
        title: "ระบบกำลังทำงาน",
        html: "โปรดรอสักครู่...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
          let data = {
            data: this.form,
            user: this.user.user,
            token: this.accessToken,
          };
          console.log(this.form);
          this.$store
            .dispatch("formSurveyModule/onSaveForm", data)
            .then((res_save) => {
              if (res_save.code == 200 && res_save.message == "success") {
                if (res_save.result) {
                  if (res_save.result.message) {
                    Swal.hideLoading();
                    Swal.fire({
                      icon: "error",
                      title: "ผิดพลาด!",
                      text: res_save.result.message,
                    });
                  } else {
                    let plant_code = res_save.result.plant_code;
                    this.$store
                      .dispatch("formSurveyModule/getForm", plant_code)
                      .then((res_formload) => {
                        if (res_formload.code == 200) {
                          if (status >= 2) {
                            this.$router.push("/Result");
                            Swal.clickConfirm();
                          } else if (status == 1) {
                            Swal.clickConfirm();
                          } else {
                            this.$router.push("/Result");
                            Swal.clickConfirm();
                          }
                        }
                      });
                  }
                }
              } else {
                Swal.hideLoading();
                Swal.fire({
                  icon: "error",
                  title: "ผิดพลาด!",
                });
              }
            });
        },
      });
    },

    //survey bio
    getPositionSurveyBio(marker) {
      this.form.survey_bio_lat = parseFloat(marker.position.lat);
      this.form.survey_bio_lon = parseFloat(marker.position.lng);
      return {
        lat: parseFloat(marker.position.lat),
        lng: parseFloat(marker.position.lng),
      };
    },
    toggleInfoSurveyBio() {
      this.infoOpened = true;
    },
    setLocationSurveyBio(marker) {
      console.log(marker);

      this.markers_survay_bio.pop();
      this.markers_survay_bio.push({ position: marker });
      this.form.survey_bio_lat = marker.lat;
      this.form.survey_bio_lon = marker.lng;
      this.startLocation.lat = this.form.survey_bio_lat;
      this.startLocation.lng = this.form.survey_bio_lon;
      this.center = marker;
      // if(this.form.location_province){
      //     this.form.location_province= null;
      //     this.form.location_district= null;
      //     this.form.location_sub_district= null;
      // }
    },
    geolocationSurveyBio() {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          var current = {
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
          };

          var google_map_pos = new google.maps.LatLng(current.lat, current.lng);

          var self = this;
          /* Use Geocoder to get address */
          var google_maps_geocoder = new google.maps.Geocoder();
          google_maps_geocoder.geocode(
            { latLng: google_map_pos }
            // function (results, status) {
            //   if (status == google.maps.GeocoderStatus.OK && results[0]) {
            //     self.getAddress(results[0]);
            //   }
            // }
          );

          this.setLocationSurveyBio(current);
        },
        (err) => {
          console.log(err);
        }
      );
    },
    setPlaceSurveyBio(place) {
      //"1839 Phahonyothin Rd, Khwaeng Lat Yao, Khet Chatuchak, Krung Thep Maha Nakhon 10900, Thailand"
      this.currentPlace = place;
      if (this.currentPlace) {
        this.form.location = place.name;
        // this.form.location_province = place.address_components[3].long_name;
        // this.form.location_district = place.address_components[2].long_name;
        // this.form.location_sub_district = place.address_components[1].long_name;

        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng(),
        };
        this.setLocationSurveyBio(marker);
        this.places.push(this.currentPlace.name);

        console.log("place", place);
        this.getAddress(place);
      } else if (this.form.name) {
        this.places.push(this.form.name);
      }
    },
    setPlaceNEWSurveyBio(place) {
      console.log("newPlace", place);
      let latLngtxt = place.latLng.toString();
      var setlatLng = latLngtxt.split(/[\s,()]+/);
      const marker = {
        lat: Number(setlatLng[1]),
        lng: Number(setlatLng[2]),
      };

      // console.log(marker);

      this.setLocationSurveyBio(marker);

      var geocoder = new google.maps.Geocoder();
      var self = this;
      geocoder.geocode(
        { location: place.latLng, language: "th" },
        function (results, status) {
          if (status === "OK") {
            // console.log("results", results);
            // results.forEach(self.getAddress);
            // self.getAddress(results[0]);
          }
        }
      );
      //
      // let newCurrentPlace = place.latLng.toString()
      // let latLng = newCurrentPlace.split(/[\s,()]+/)
      // this.currentPosition = { lat: Number(latLng[1]), lng: Number(latLng[2]) }
      // console.log(place);
    },

    //survey plot
    getPositionSurveyPlot(marker) {
      this.form.survey_plot_lat = parseFloat(marker.position.lat);
      this.form.survey_plot_lon = parseFloat(marker.position.lng);
      return {
        lat: parseFloat(marker.position.lat),
        lng: parseFloat(marker.position.lng),
      };
    },
    toggleInfoSurveyPlot() {
      this.infoOpened = true;
    },
    setLocationSurveyPlot(marker) {
      console.log(marker);

      this.markers_survay_plot.pop();
      this.markers_survay_plot.push({ position: marker });
      this.form.survey_plot_lat = marker.lat;
      this.form.survey_plot_lon = marker.lng;
      this.startLocation.lat = this.form.survey_plot_lat;
      this.startLocation.lng = this.form.survey_plot_lon;
      this.center = marker;
      // if(this.form.location_province){
      //     this.form.location_province= null;
      //     this.form.location_district= null;
      //     this.form.location_sub_district= null;
      // }
    },
    geolocationSurveyPlot() {
      console.log("current location", navigator.geolocation);
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          var current = {
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
          };

          var google_map_pos = new google.maps.LatLng(current.lat, current.lng);

          var self = this;
          /* Use Geocoder to get address */
          var google_maps_geocoder = new google.maps.Geocoder();
          google_maps_geocoder.geocode(
            { latLng: google_map_pos }
            // function (results, status) {
            //   if (status == google.maps.GeocoderStatus.OK && results[0]) {
            //     self.getAddress(results[0]);
            //   }
            // }
          );

          this.setLocationSurveyPlot(current);
        },
        (err) => {
          console.log(err);
        }
      );
    },
    setPlaceSurveyPlot(place) {
      //"1839 Phahonyothin Rd, Khwaeng Lat Yao, Khet Chatuchak, Krung Thep Maha Nakhon 10900, Thailand"
      this.currentPlace = place;
      if (this.currentPlace) {
        this.form.location = place.name;
        // this.form.location_province = place.address_components[3].long_name;
        // this.form.location_district = place.address_components[2].long_name;
        // this.form.location_sub_district = place.address_components[1].long_name;

        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng(),
        };
        this.setLocationSurveyPlot(marker);
        this.places.push(this.currentPlace.name);

        console.log("place", place);
        this.getAddress(place);
      } else if (this.form.name) {
        this.places.push(this.form.name);
      }
    },
    setPlaceNEWSurveyPlot(place) {
      console.log("newPlace", place);
      let latLngtxt = place.latLng.toString();
      var setlatLng = latLngtxt.split(/[\s,()]+/);
      const marker = {
        lat: Number(setlatLng[1]),
        lng: Number(setlatLng[2]),
      };

      // console.log(marker);

      this.setLocationSurveyPlot(marker);

      var geocoder = new google.maps.Geocoder();
      var self = this;
      geocoder.geocode(
        { location: place.latLng, language: "th" },
        function (results, status) {
          if (status === "OK") {
            console.log("results", results);
            // results.forEach(self.getAddress);
            // self.getAddress(results[0]);
          }
        }
      );
      //
      // let newCurrentPlace = place.latLng.toString()
      // let latLng = newCurrentPlace.split(/[\s,()]+/)
      // this.currentPosition = { lat: Number(latLng[1]), lng: Number(latLng[2]) }
      // console.log(place);
    },

    //bank bio
    getPositionBankBio(marker) {
      this.form.bank_bio_lat = parseFloat(marker.position.lat);
      this.form.bank_bio_lon = parseFloat(marker.position.lng);
      return {
        lat: parseFloat(marker.position.lat),
        lng: parseFloat(marker.position.lng),
      };
    },
    toggleInfoBankBio() {
      this.infoOpened = true;
    },
    setLocationBankBio(marker) {
      console.log(marker);

      this.markers_bank_bio.pop();
      this.markers_bank_bio.push({ position: marker });
      this.form.bank_bio_lat = marker.lat;
      this.form.bank_bio_lon = marker.lng;
      this.startLocation3.lat = this.form.bank_bio_lat;
      this.startLocation3.lng = this.form.bank_bio_lon;
      this.center = marker;
      // if(this.form.location_province){
      //     this.form.location_province= null;
      //     this.form.location_district= null;
      //     this.form.location_sub_district= null;
      // }
    },
    geolocationBankBio() {
      console.log("current location", navigator.geolocation);
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          var current = {
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
          };

          var google_map_pos = new google.maps.LatLng(current.lat, current.lng);

          var self = this;
          /* Use Geocoder to get address */
          var google_maps_geocoder = new google.maps.Geocoder();
          google_maps_geocoder.geocode(
            { latLng: google_map_pos }
            // function (results, status) {
            //   if (status == google.maps.GeocoderStatus.OK && results[0]) {
            //     self.getAddress(results[0]);
            //   }
            // }
          );

          this.setLocationBankBio(current);
        },
        (err) => {
          console.log(err);
        }
      );
    },
    setPlaceBankBio(place) {
      //"1839 Phahonyothin Rd, Khwaeng Lat Yao, Khet Chatuchak, Krung Thep Maha Nakhon 10900, Thailand"
      this.currentPlace = place;
      if (this.currentPlace) {
        this.form.location = place.name;
        // this.form.location_province = place.address_components[3].long_name;
        // this.form.location_district = place.address_components[2].long_name;
        // this.form.location_sub_district = place.address_components[1].long_name;

        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng(),
        };
        this.setLocationBankBio(marker);
        this.places.push(this.currentPlace.name);

        console.log("place", place);
        this.getAddress(place);
      } else if (this.form.name) {
        this.places.push(this.form.name);
      }
    },
    setPlaceNEWBankBio(place) {
      console.log("newPlace", place);
      let latLngtxt = place.latLng.toString();
      var setlatLng = latLngtxt.split(/[\s,()]+/);
      const marker = {
        lat: Number(setlatLng[1]),
        lng: Number(setlatLng[2]),
      };

      this.setLocationBankBio(marker);
    },

    //bank plot
    getPositionBankPlot(marker) {
      this.form.bank_plot_lat = parseFloat(marker.position.lat);
      this.form.bank_plot_lon = parseFloat(marker.position.lng);
      return {
        lat: parseFloat(marker.position.lat),
        lng: parseFloat(marker.position.lng),
      };
    },
    toggleInfoBankPlot() {
      this.infoOpened = true;
    },
    setLocationBankPlot(marker) {
      console.log(marker);

      this.markers_bank_plot.pop();
      this.markers_bank_plot.push({ position: marker });
      this.form.bank_plot_lat = marker.lat;
      this.form.bank_plot_lon = marker.lng;
      this.startLocation4.lat = this.form.bank_plot_lat;
      this.startLocation4.lng = this.form.bank_plot_lon;
      this.center = marker;
      // if(this.form.location_province){
      //     this.form.location_province= null;
      //     this.form.location_district= null;
      //     this.form.location_sub_district= null;
      // }
    },
    geolocationBankPlot() {
      console.log("current location", navigator.geolocation);
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          var current = {
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
          };

          var google_map_pos = new google.maps.LatLng(current.lat, current.lng);

          var self = this;
          /* Use Geocoder to get address */
          var google_maps_geocoder = new google.maps.Geocoder();
          google_maps_geocoder.geocode(
            { latLng: google_map_pos }
            // function (results, status) {
            //   if (status == google.maps.GeocoderStatus.OK && results[0]) {
            //     self.getAddress(results[0]);
            //   }
            // }
          );

          this.setLocationBankPlot(current);
        },
        (err) => {
          console.log(err);
        }
      );
    },
    setPlaceBankPlot(place) {
      //"1839 Phahonyothin Rd, Khwaeng Lat Yao, Khet Chatuchak, Krung Thep Maha Nakhon 10900, Thailand"
      this.currentPlace = place;
      if (this.currentPlace) {
        this.form.location = place.name;
        // this.form.location_province = place.address_components[3].long_name;
        // this.form.location_district = place.address_components[2].long_name;
        // this.form.location_sub_district = place.address_components[1].long_name;

        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng(),
        };
        this.setLocationBankPlot(marker);
        this.places.push(this.currentPlace.name);

        console.log("place", place);
        this.getAddress(place);
      } else if (this.form.name) {
        this.places.push(this.form.name);
      }
    },
    setPlaceNEWBankPlot(place) {
      console.log("newPlace", place);
      let latLngtxt = place.latLng.toString();
      var setlatLng = latLngtxt.split(/[\s,()]+/);
      const marker = {
        lat: Number(setlatLng[1]),
        lng: Number(setlatLng[2]),
      };

      // console.log(marker);

      this.setLocationBankPlot(marker);
    },

    getTooltip(key) {
      let Name = this.tooltipName.filter((tooltip) => {
        return tooltip.name == key;
      });
      return Name[0].tooltip_name;
    },
    verifyData(data) {
      let errorList = [];
      if (!data.bio_code.length) errorList.push(" รหัสพันธ์พืช");
      if (!data.bio_name.length) errorList.push(" ชื่อพันธ์ุพืช");
      if (!data.bio_local_name.length) errorList.push(" ชื่อท้องถิน");
      if (this.category_selected && this.category_selected.length <= 0)
        errorList.push(" กลุ่มชนิดพืช");
      if (this.habit_selected && this.habit_selected.length <= 0)
        errorList.push(" ลักษณะวิสัยพืช");
      if (this.habitat_selected && this.habitat_selected.length <= 0)
        errorList.push(" แหล่งที่พบ");
      if (!data.survey_date) errorList.push(" วันที่สำรวจ");

      let tempDataBank = document.getElementsByClassName("bank");
      let counting_bank = 0;
      tempDataBank.forEach((item) => {
        if (item.value) {
          counting_bank++;
        }
      });
      // if (counting_bank > 0) {
      if (!data.bank_date) errorList.push(" วันที่จัดเก็บ ข้อมูลธนาคาร");
      if (!data.bank_plot_address) errorList.push(" ที่ตั้งแปลง ข้อมูลธนาคาร");
      if (
        this.province_bank_selected &&
        this.province_bank_selected.length <= 0
      )
        errorList.push(" จังหวัด ข้อมูลธนาคาร");
      if (
        this.district_bank_selected &&
        this.district_bank_selected.length <= 0
      )
        errorList.push(" อำเภอ ข้อมูลธนาคาร");
      if (
        this.sub_district_bank_selected &&
        this.sub_district_bank_selected.length <= 0
      )
        errorList.push(" ตำบล ข้อมูลธนาคาร");
      // if (
      //   !data.bank_date ||
      //   !data.bank_plot_address ||
      //   this.province_bank_selected.length <= 0 ||
      //   this.district_bank_selected.length <= 0 ||
      //   this.sub_district_bank_selected.length <= 0 ||
      //   !data.bank_plot_lat ||
      //   !data.bank_plot_lon
      // ) {
      //   errorList.push(" ตำแหน่งที่สำรวจ");
      //   countingError++;
      // }
      // } else {
      //   this.bank_date = "";
      //   this.bank_plot_address = "";
      //   this.province_bank_selected.length = [];
      //   this.district_bank_selected.length = [];
      //   this.sub_district_bank_selected.length = [];
      //   this.bank_plot_lat = "";
      //   this.bank_plot_lon = "";
      // }

      // if (
      //   !data.bio_code.length ||
      //   !data.bio_name.length ||
      //   !data.bio_local_name.length ||
      //   this.category_selected.length <= 0 ||
      //   this.habit_selected.length <= 0 ||
      //   this.habitat_selected.length <= 0
      // ) {
      //   countingError++;
      //   console.log("counting", countingError);
      // } else if (
      //   !data.survey_date ||
      //   !data.survey_bio_lat ||
      //   !data.survey_bio_lat
      // ) {
      //   countingError++;
      //   console.log("survey_date  survey_bio_lat survey_bio_lat ", countingError);
      // }
      console.log(errorList);
      return errorList;
    },
    prepareKnowLedge() {
      let tempForm = [];
      this.form.plant_knowledges.forEach((value, index) => {
        if (value.knowledge_description) {
          this.checkInput[value.knowledges1.knowledge_level1_id] = true;
          this.checkInput[
            value.knowledges1.knowledge_level1_id +
              "_" +
              value.knowledges1.knowledge_level2_id
          ] = true;
        }
        tempForm[value.knowledge_id] = value.knowledge_description;
      });
      this.form.knowledge = tempForm;
    },

    async getDistrict(province, name) {
      if (province) {
        let filter = [];
        filter = this.district.filter((data) => {
          return data.province_id == province.code;
        });
        let data = {
          name: name,
          filter: filter,
        };
        this[`district_${name}`] = data.filter;
        // this.$store.dispatch("OptionsModule/setFilterDistrict", data);
      } else {
        this[`province_${name}_selected`] = [];
        this[`district_${name}_selected`] = [];
        this[`sub_district_${name}_selected`] = [];
      }
    },
    async getSubDistrict(district, name) {
      if (district) {
        let filter = [];
        filter = this.sub_district.filter((data) => {
          return data.district_id == district.district_id;
        });
        let data = {
          name: name,
          filter: filter,
        };
        this[`sub_district_${name}`] = data.filter;
        // this.$store.dispatch("OptionsModule/setFilterSubDistrict", data);
      } else {
        this[`district_${name}_selected`] = [];
        this[`sub_district_${name}_selected`] = [];
      }
    },
    getHabitat(id) {
      let filter = [];
      filter = this.habitats.filter((data) => {
        return data.habitat_id == id;
      });
      let data = {
        id: id,
        name: filter[0].name,
      };
      return data;
    },
    setProvince(id) {
      let filter = [];
      filter = this.province.filter((data) => {
        return data.code == id;
      });
      let data = {
        id: id,
        name: filter[0].name,
      };
      return data;
    },
    setDistrict(id) {
      let filter = [];
      filter = this.district.filter((data) => {
        return data.district_id == id;
      });
      let data = {
        id: id,
        name: filter[0].name,
      };
      return data;
    },
    setSubDistrict(id) {
      if (id) {
        let filter = [];
        filter = this.sub_district.filter((data) => {
          return data.subdistrict_id == id;
        });
        let data = {
          id: id,
          name: filter[0].name,
        };
        return data;
      }
    },
    chooseFiles() {
      document.getElementById("imgUpload").click();
    },
    uploadImage(event, index) {
      if (event.target.files.length > 0) {
        let input = event.target;
        var formData = new FormData();
        formData.append("image", input.files[0]);
        formData.append("token", this.accessToken);
        axios({
          method: "post",
          url: domain + "/api/uploadImage",
          data: formData,
          headers: { "Content-Type": "multipart/form-data" },
        }).then((res) => {
          this.image_set[index].image_url = res.data.result.image_url;
        });
      }
    },
    deleteImage(i) {
      this.image_set[i].image_url = null;
    },
    async addImage(image) {
      var formData = new FormData();
      formData.append("data", image.blob);
      formData.append("type", image.type);
      formData.append("token", this.accessToken);
      console.log("formData", formData);
      axios({
        method: "post",
        url: domain + "/api/uploadImage",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      }).then((res) => {
        this.form.images.push(res.data.result);
      });
    },
    goBack() {
      if (this.user.user.group_id === 4 || this.form.status_id !== 1) {
        this.$router.push("/Result");
      } else {
        this.$router.push("/Survey");
      }
    },
    deletePlant() {
      Swal.fire({
        title: "ต้องการลบข้อมูล?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ตกลง",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: "ระบบกำลังทำงาน",
            html: "โปรดรอสักครู่...",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
              this.$store
                .dispatch("formSurveyModule/onDeletePlant", this.form.plant_id)
                .then((res) => {
                  if (res.code == 200) {
                    Swal.fire({
                      icon: "success",
                      title: "ลบสำเร็จ",
                    });
                    this.goBack();
                  } else {
                    Swal.fire({
                      icon: "error",
                      title: "ผิดพลาด!",
                    });
                  }
                });
            },
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
.close-icon {
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}

.modal {
  z-index: 1001 !important;
}
.modal-backdrop {
  z-index: 1000 !important;
}
.pac-container {
  z-index: 1055 !important;
}

.delete-img {
  position: absolute;
  color: #faf8f8;
  top: 36%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  width: 40px;
  height: auto;
}

ol,
ul,
dl {
  margin: 0 !important;
}

.vux-uploader_hd {
  display: block !important;
}

.vux-uploader .vux-uploader_hd .vux-uploader_title {
  display: block !important;
  text-align: center !important;
}

.vux-uploader .vux-uploader_bd .vux-uploader_files {
  list-style: none;
  padding: 0;
}

.vux-uploader .vux-uploader_bd {
  overflow: hidden;
  margin-left: 0 !important;
  margin-right: auto !important;
  padding: 0 !important;
  display: flex;
  justify-content: center;
  margin: 0;
}

.vux-uploader .vux-uploader_bd .vux-uploader_input-box {
  float: left;
  position: relative;
  margin: 0;

  width: 77px;
  height: 77px;
  border: 1px solid #d9d9d9;
}
</style>
